import { ChangeDetectorRef, ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { FikoThreeJsComponent } from '../../../fiko-three-js.component';
import { FikoSecililer } from '../../FikoSecililer';
import { FikoVektor3D } from '../../FikoVektor3d';
import * as THREE from 'three';
import { FikoYTService } from '@/src/service/fikoyt.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { FikoOlcumCizgisi, OlcumTuru } from '../../FikoOlcumCizgisi';
import { CetvelMathService } from './cetvel-math.service';
import { CetvelGeometryService } from './cetvel-geometry.service';
import { CetvelSelectionService } from './cetvel-selection.service';
import { FikoRaycastConfigService } from '../../../services/fiko-raycast-config.service';
import { FikoOlcumBase, SecimTuru, SECIM_FILTRE_HARITASI } from '../fiko-olcum-base';
import { gpuOlcumMotoru } from '../gpu/GPUOlcumMotoru';
import { FikoOlcumler } from '../../FikoOlcumler';
import { FikoKaliciOlcumler } from '../../FikoKaliciOlcumler';
import { FikoKaynakca } from '../../FikoThreeCam/FikoKaynakca';
import { DimensionIntegrationService } from '../dimension/DimensionIntegration.service';
import { flatness, cylindricity, bestFitPlane, yonelimSapma } from '../gdt/FikoGDTVerify';
import { FikoGDTAnnotator, GDT_SEMBOL } from '../gdt/FikoGDTAnnotator';
import { miCember } from '../../FikoYT-Fonksiyonlar';
import { LineGeometry } from 'three/examples/jsm/lines/LineGeometry.js';
import { LineMaterial } from 'three/examples/jsm/lines/LineMaterial.js';
import { LineSegments2 } from 'three/examples/jsm/lines/LineSegments2.js';


@Component({
  selector: 'fikoyt-cetvel',
  templateUrl: './cetvel.component.html',
  styleUrls: ['./cetvel.component.scss'],
  imports: [CommonModule, FormsModule,],
  providers: [CetvelMathService, CetvelGeometryService, CetvelSelectionService],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CetvelComponent extends FikoOlcumBase implements OnInit, OnDestroy {
  // ========== SESSION & KALICI ÖLÇÜM SİSTEMİ ==========
  /** Her dialog açılışında benzersiz session ID üretilir */
  sessionId: string = '';
  /** Kalıcı ölçümler grubu referansı (FikoKaynakca altında) */
  private kaliciOlcumlerGrubu: FikoKaliciOlcumler | null = null;

  /** 🎯 GD&T FCF sembol yöneticisi (3D sahnede tolerans sembolleri) */
  private gdtAnnotator: FikoGDTAnnotator = new FikoGDTAnnotator(null);

  // 🎯 AKILLI ÇAP: dairesel kenar hover'da çap önizleme (sprite reuse + kenar-değişince cache → donmasız)
  private cemberPreviewSprite: THREE.Sprite | null = null;
  private cemberPreviewCanvas: HTMLCanvasElement | null = null;
  private cemberPreviewTexture: THREE.CanvasTexture | null = null;
  private cemberPreviewSonCap: number = -1;
  private _sonCemberEdgeId: number | undefined = undefined;

  // ========== CETVEL-SPECIFIC PROPERTIES ==========
  sonuc1Tipi: "Nokta" | "Çizgi" | "Yüzey" | "Grup" | null = null;

  secilen1: any = null;
  /** */
  //---> RS+: Fiko Seçimci
  fikoSecim2: FikoSecililer;
  secim2Filitre: any[] | "*" = "*";
  //---> RS+: 
  private _secim2Turu: string = "Her Şey";
  public get secim2Turu(): string {
    return this._secim2Turu;
  }
  public set secim2Turu(v: string) {
    this._secim2Turu = v;
    if (!this.fikoSecim2) return;

    this.fikoSecim2.temizle();

    // Seçim türüne göre merkezi raycast profilini uygula
    if (v == "Her Şey") {
      this.secim2Filitre = "*"
      this.raycastConfigService.applyProfile('EVERYTHING');
    }
    else if (v == "Sadece Nokta") {
      this.secim2Filitre = ["Points", "FikoCizimYalin"];
      this.raycastConfigService.applyProfile('POINTS_ONLY');
    }
    else if (v == "Sadece Çizgi") {
      this.secim2Filitre = ["LineSegments", "LineSegments2", "Line2", "LineGeometry", "FikoCizimYalin"];
      this.raycastConfigService.applyProfile('LINES_ONLY');
    }
    else if (v == "Sadece Yüzey") {
      this.secim2Filitre = ["Mesh", "FikoCizimYalin"];
      this.raycastConfigService.applyProfile('MESH_ONLY');
    }
    else if (v == "Sadece Gruplar") {
      this.secim2Filitre = ["FikoEksen", "FikoGrup", "FikoCizimYalin"];
      this.raycastConfigService.applyProfile('DEFAULT');
    }
    else if (v == "Nokta Koy") {
      // 🎯 CATIA-STYLE: Tüm geometri türlerinde nokta koyabilmek için EVERYTHING kullan
      this.secim2Filitre = ["Nokta Koy"];
      this.raycastConfigService.applyProfile('EVERYTHING');

      // 🎯 NOKTA KOY: Mod değiştiğinde sadece secim2 highlight'larını temizle (secim1'i koru!)
      if (this.fikoSecim2.grupSecimler2) {
        this.fikoSecim2.grupSecimler2.clear();
      }
      // NOT: grupSecimlerUzerinde hover için, onu da temizle
      if (this.fikoSecim2.grupSecimlerUzerinde) {
        this.fikoSecim2.grupSecimlerUzerinde.clear();
      }
    }

    // Raycast params'i doğrudan set et (servisten config al)
    this.fikoSecim2.raycaster.params = this.raycastConfigService.getRaycastParams();

    // 🎯 NOKTA KOY: Tüm objelerde raycast yapabilmek için "*" kullan
    if (Array.isArray(this.secim2Filitre) && this.secim2Filitre.indexOf("Nokta Koy") > -1) {
      this.fikoSecim2.filitreler = "*";
    } else {
      this.fikoSecim2.filitreler = this.secim2Filitre;
    }
    this.fikoSecim2.rayObje = this.anaGosterim.sahneler[0].children;

    if (this.anaGosterim && this.anaGosterim.ciz) {
      this.anaGosterim.ciz();
    }
    this.CD.detectChanges();
  }
  sonuc2Tipi: "Nokta" | "Çizgi" | "Yüzey" | "Grup" | null = null;

  secilen2: any = null;
  /** */
  // Birim Dönüştürme Sabitleri - dinamik olarak ayarlanabilir
  private _birimFaktore: { [key: string]: number } = { 'mm': 1, 'cm': 0.1, 'inch': 0.03937, 'm': 0.001 };
  public get birimFaktore(): { [key: string]: number } {
    return this._birimFaktore;
  }
  public set birimFaktore(v: { [key: string]: number }) {
    this._birimFaktore = v;
  }

  // Seçilen Birim
  private _secilenBirim: string = 'mm';
  get secilenBirim(): string {
    return this._secilenBirim;
  }
  set secilenBirim(v: string) {
    this._secilenBirim = v;
    // 🔴 BUGFIX: Birim değişirse ölçümü güncelle
    if (this.secilen1 && this.secilen2) {
      this.hesapla();
    }
  }

  // Ölçüm Geçmişi (Son 20 ölçüm)
  olcumGecmisi: Array<{
    aciklama: string,
    olcu: number,
    birim: string,
    zaman: Date,
    tur: string // Nokta-Nokta, Çizgi-Yüzey vb
  }> = [];

  // ===== CETVEL-SPECIFIC AYARLAR =====
  // NOT: Highlight, Nokta Koy, CATIA ve Olcum cizgisi ayarlari base class'tan miras alinir
  parallelKontrol: number = 0.001;
  yuzeyMesafeTolerAnsi: number = 0.0001;
  mesafeBas: number = 2;
  aciBasamak: number = 1;
  ondalikSayiBas: number = 2;
  olcumGecmisiLimiti: number = 20;
  planeGeometriBoyu: number = 1000;

  // Yüzey Tipi Bilgisi
  yuzey1TipiInfo: any = null;
  yuzey2TipiInfo: any = null;

  // 🎯 ÖLÇÜM MODU: Radiüslü yüzey/edge seçildiğinde hangi mesafe ölçülecek
  // 'enKisa' = gerçek en kısa (çapraz olabilir), 'enKisaDuz' = düzleme dik en kısa
  // 'merkez' = merkeze, 'enUzak' = en uzak (çapraz), 'enUzakDuz' = en uzak (düz/paralel)
  secim1OlcumModu: 'enKisa' | 'enKisaDuz' | 'merkez' | 'enUzak' | 'enUzakDuz' = 'enKisaDuz';
  secim2OlcumModu: 'enKisa' | 'enKisaDuz' | 'merkez' | 'enUzak' | 'enUzakDuz' = 'enKisaDuz';
  // Eski boolean'lar için getter (geriye uyumluluk)
  get secim1MerkezModu(): boolean { return this.secim1OlcumModu === 'merkez'; }
  set secim1MerkezModu(v: boolean) { this.secim1OlcumModu = v ? 'merkez' : 'enKisa'; }
  get secim2MerkezModu(): boolean { return this.secim2OlcumModu === 'merkez'; }
  set secim2MerkezModu(v: boolean) { this.secim2OlcumModu = v ? 'merkez' : 'enKisa'; }
  // Merkez bilgisi (silindir/küre/çember tespiti sonucu)
  secim1MerkezBilgisi: { merkez: THREE.Vector3, yaricap: number, tip?: string } | null = null;
  secim2MerkezBilgisi: { merkez: THREE.Vector3, yaricap: number, tip?: string } | null = null;

  // ===== PERFORMANS CACHE SİSTEMİ - CATIA SEVİYESİ =====
  // NOT: Selection settings base class'tan miras alinir
  private hesaplaCache: Map<string, any> = new Map();
  private lastCalculationTime: number = 0; // Throttle için

  // Seçim 1 ve 2 Geometrileri Yedekleme
  secilen1Geom: THREE.BufferGeometry | null = null;
  secilen2Geom: THREE.BufferGeometry | null = null;

  // Seçim Vertex Index'leri (geometry'den doğru noktayı almak için)
  secilen1PointIndex: number | null = null;
  secilen2PointIndex: number | null = null;

  // 🎯 NOKTA KOY: Hover için (Cetvel-specific - dual selection)
  // NOT: kaliciNoktalar, fikoOlcumCizgisi, fikoOlcumlerGrubu base class'tan miras alinir
  private hoverNoktaPoints1: THREE.Points | null = null;
  private hoverNoktaPoints2: THREE.Points | null = null;

  // 🎯 PROJEKSİYON: Reusable vektörler (allocation önleme - performans)
  private readonly _projVA = new THREE.Vector3();
  private readonly _projVB = new THREE.Vector3();
  private readonly _projVC = new THREE.Vector3();

  // 🎯 NOKTA KOY: Son geçerli kesişim bilgisi (hızlı tıklamada doğru pozisyon için)
  private sonGecerliKesisim1: any = null;
  private sonGecerliKesisim2: any = null;

  // 🎯 PERFORMANS: Hover throttle (zoom/pan sırasında takılma önleme)
  private lastHoverRenderTime: number = 0;
  private readonly HOVER_THROTTLE_MS = 16; // ~60 FPS

  // ⚡ LIVE PREVIEW: İlk seçim sonrası hover'da mesafe önizleme çizgisi
  private previewLine: LineSegments2 | null = null;
  private previewLineGeometry: LineGeometry | null = null;
  private previewLabel: THREE.Sprite | null = null;
  private previewLabelCanvas: HTMLCanvasElement | null = null;
  private previewLabelTexture: THREE.CanvasTexture | null = null;

  // 🎯 BREP CURSOR: Surface/Edge type'a göre cursor değiştirme (SVG inline)
  private sonCursor: string = '';

  // 🎯 ARAÇ STATE YEDEK: baslat'ta FikoSecililer durumu yedeklendi mi (bitir'de geri yüklenir)
  private _secimDurumYedekli: boolean = false;
  private _svgCursorsCache: { [key: string]: string } | null = null;

  /** SVG string'i CSS cursor data URL'ine çevirir - hotspot ok ucunda (1,1) */
  private svgToCursor(svg: string): string {
    const encoded = encodeURIComponent(svg.replace(/\s+/g, ' ').trim());
    return `url("data:image/svg+xml,${encoded}") 1 1, auto`;
  }

  /** 🎯 SVG CURSOR SISTEMI: Sarı-yeşil ok temalı cetvel cursorları (cetvel-bos.png stilinde) */
  private get SVG_CURSORS(): { [key: string]: string } {
    if (!this._svgCursorsCache) {
      // Ortak cetvel ok şekli - sarı-yeşil gradient
      const cetvelOk = `<defs><linearGradient id="cg" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" stop-color="#ffeb3b"/><stop offset="100%" stop-color="#4caf50"/></linearGradient></defs><polygon points="1,1 1,22 5,18 9,26 13,24 9,16 17,16" fill="url(#cg)" stroke="#2e7d32" stroke-width="1.2"/><line x1="3" y1="5" x2="7" y2="9" stroke="#1b5e20" stroke-width="1.2"/><line x1="3" y1="9" x2="5" y2="11" stroke="#1b5e20" stroke-width="0.8"/><line x1="3" y1="13" x2="7" y2="17" stroke="#1b5e20" stroke-width="1.2"/>`;

      this._svgCursorsCache = {
        // Boş cetvel (sadece ok)
        bos: this.svgToCursor(`<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">${cetvelOk}</svg>`),
        // Nokta sembolü (kırmızı daire)
        nokta: this.svgToCursor(`<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">${cetvelOk}<circle cx="26" cy="6" r="5" fill="#f44336" stroke="#fff" stroke-width="1.5"/></svg>`),
        // Düzlem yüzey (mavi kare)
        yuzeyDuzlem: this.svgToCursor(`<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">${cetvelOk}<rect x="20" y="1" width="10" height="10" fill="#2196f3" fill-opacity="0.7" stroke="#1565c0" stroke-width="1.5"/></svg>`),
        // Dairesel yüzey (mor daire)
        yuzeyDairesel: this.svgToCursor(`<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">${cetvelOk}<circle cx="25" cy="6" r="5" fill="#9c27b0" fill-opacity="0.7" stroke="#6a1b9a" stroke-width="1.5"/></svg>`),
        // Dalgalı yüzey (turuncu dalga)
        yuzeyDalgali: this.svgToCursor(`<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">${cetvelOk}<path d="M19 6 Q22 2, 25 6 Q28 10, 31 6" fill="none" stroke="#ff9800" stroke-width="2.5" stroke-linecap="round"/></svg>`),
        // Düz çizgi (turkuaz çizgi)
        cizgiDuz: this.svgToCursor(`<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">${cetvelOk}<line x1="19" y1="10" x2="31" y2="2" stroke="#00bcd4" stroke-width="2.5" stroke-linecap="round"/></svg>`),
        // Dairesel çizgi (pembe yay)
        cizgiDairesel: this.svgToCursor(`<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">${cetvelOk}<path d="M19 10 A8 8 0 0 1 31 2" fill="none" stroke="#e91e63" stroke-width="2.5" stroke-linecap="round"/></svg>`),
        // Dalgalı çizgi (sarı dalga)
        cizgiDalgali: this.svgToCursor(`<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">${cetvelOk}<path d="M19 6 Q22 2, 25 6 Q28 10, 31 6" fill="none" stroke="#ffc107" stroke-width="2.5" stroke-linecap="round"/></svg>`)
      };
    }
    return this._svgCursorsCache;
  }

  private get varsayilanCursor(): string {
    return this.SVG_CURSORS.bos;
  }

  // İkinci FikoOlcumCizgisi - Açılı yüzeylerde en kısa mesafe için (Cetvel-specific)
  private fikoOlcumCizgisi2: FikoOlcumCizgisi | null = null;

  // 🎯 YENİ DIMENSION SİSTEMİ
  private dimensionService: DimensionIntegrationService | null = null;
  useNewDimensionSystem: boolean = true;  // true = yeni sistem, false = eski FikoOlcumCizgisi
  /** Klasik uzatma çizgisi: true = eski paralel witness; false = yüzeye değen (bbox) witness */
  klasikUzatma: boolean = false;

  // Ana Sonuç
  sonuc: {
    turu: "Mesafe" | "Hata",
    nokta?: {
      x?: number | string, y?: number | string, z?: number | string,
      vektor?: FikoVektor3D,
    },
    yuzey?: {
      alan?: number | string,
      agirlikMerkezi?: FikoVektor3D,
      duzlem?: THREE.Plane,
      miDuzlemsel?: boolean,
      tipi?: string,
      tipiBilgisi?: any,
    },
    cizgi?: any,
    mesafe?: {
      aciklama: string,
      olcu: number,
      birim: string,
      min?: number,
      max?: number,
      ortalama?: number,
      toleransMin?: number,
      toleransMax?: number,
    }
  } = null;

  // NOT: anaGosterim base class'tan miras alinir

  constructor(
    FikoYT: FikoYTService,
    CD: ChangeDetectorRef,
    raycastConfigService: FikoRaycastConfigService,
    public readonly mathService: CetvelMathService,
    public readonly geomService: CetvelGeometryService,
    public readonly selectionService: CetvelSelectionService
  ) {
    super(FikoYT, CD, raycastConfigService);
  }

  /**
   * Kaydedilen ayarları yükle - base class metodunu kullanır
   */
  override ngOnInit() {
    // Base class'tan ortak ayarlari yukle (highlight, CATIA, selection settings)
    super.loadAyarlar();
    // Cetvel'e ozel ayarlari yukle
    this.loadCetvelAyarlari();
  }

  /**
   * Cetvel'e ozel ayarlari yukle
   */
  private loadCetvelAyarlari(): void {
    const kaydedilen = localStorage.getItem('FikoYTOlcumAyarlari');
    if (!kaydedilen) return;

    try {
      const parsed = JSON.parse(kaydedilen);

      // Cetvel-specific ayarlar
      if (parsed.parallelKontrol !== undefined) this.parallelKontrol = parsed.parallelKontrol;
      if (parsed.yuzeyMesafeTolerAnsi !== undefined) this.yuzeyMesafeTolerAnsi = parsed.yuzeyMesafeTolerAnsi;
      if (parsed.mesafeBas !== undefined) this.mesafeBas = parsed.mesafeBas;
      if (parsed.aciBasamak !== undefined) this.aciBasamak = parsed.aciBasamak;
      if (parsed.ondalikSayiBas !== undefined) this.ondalikSayiBas = parsed.ondalikSayiBas;
      if (parsed.olcumGecmisiLimiti !== undefined) this.olcumGecmisiLimiti = parsed.olcumGecmisiLimiti;
      if (parsed.planeGeometriBoyu !== undefined) this.planeGeometriBoyu = parsed.planeGeometriBoyu;

      // Birim ayarlari
      if (parsed.secilenBirim !== undefined) this.secilenBirim = parsed.secilenBirim;
      if (parsed.ciBirimFaktore !== undefined || parsed.inchFaktore !== undefined || parsed.mFaktore !== undefined) {
        const yeniBirimFaktore = { ...this._birimFaktore };
        if (parsed.ciBirimFaktore !== undefined) yeniBirimFaktore['cm'] = parsed.ciBirimFaktore;
        if (parsed.inchFaktore !== undefined) yeniBirimFaktore['inch'] = parsed.inchFaktore;
        if (parsed.mFaktore !== undefined) yeniBirimFaktore['m'] = parsed.mFaktore;
        this.birimFaktore = yeniBirimFaktore;
      }

      // Secim ayarlari
      if (parsed.secim2Turu !== undefined) this.secim2Turu = parsed.secim2Turu;

      // Olcum modu
      const varsayilanMod = this.getVarsayilanOlcumModu();
      this.secim1OlcumModu = varsayilanMod;
      this.secim2OlcumModu = varsayilanMod;

      this.CD.detectChanges();
    } catch (e) {
      // Hata durumunda varsayilanlari kullan
    }
  }

  // Ölçüm Geçmişine Ekle
  olcumGecmisineEkle(aciklama: string, olcu: number, birim: string, tur: string) {
    this.olcumGecmisi.unshift({
      aciklama,
      olcu,
      birim,
      zaman: new Date(),
      tur
    });

    // Ayarlanabilir limit sayısını tut
    if (this.olcumGecmisi.length > this.olcumGecmisiLimiti) {
      this.olcumGecmisi.pop();
    }
  }

  // Birim dönüştürme (template'ten çağrılıyor)
  birimDonustur(deger: number, kaynakBirim: string, hedefBirim: string): number {
    return this.geomService.birimDonustur(deger, kaynakBirim, hedefBirim);
  }

  /**
   * 🎯 ÖLÇÜM MODU TOGGLE: Seçim 1 için ölçüm modunu değiştir
   * Döngü: enKisa -> merkez -> enUzak -> enUzakDuz -> enKisa
   * Sadece Seçim 1'i değiştirir, Seçim 2'yi değiştirmez
   */
  toggleSecim1OlcumModu(): void {
    // 🎯 DÜZLEM YÜZEY: Düzlem yüzeylerde "merkez" modu anlamsız, atla
    const duzlemMi = this.secim1MerkezBilgisi?.tip === 'duzlem';
    const modSirasi: Array<'enKisa' | 'enKisaDuz' | 'merkez' | 'enUzak' | 'enUzakDuz'> = duzlemMi
      ? ['enKisaDuz', 'enKisa', 'enUzak', 'enUzakDuz'] // Düzlemde merkez yok
      : ['enKisaDuz', 'enKisa', 'merkez', 'enUzak', 'enUzakDuz'];
    const mevcutIndex = modSirasi.indexOf(this.secim1OlcumModu);
    const yeniIndex = (mevcutIndex + 1) % modSirasi.length;
    const yeniMod = modSirasi[yeniIndex];
    // 🎯 Sadece Seçim 1'i değiştir (Seçim 2'yi değiştirme!)
    this.secim1OlcumModu = yeniMod;
    // 🎯 LocalStorage'a varsayılan mod olarak kaydet (sonraki YENİ seçimler için)
    this.kaydetOlcumModu(yeniMod);
    // Cache'i temizle ve yeniden hesapla
    this.cacheiTemizle();
    if (this.secilen1 && this.secilen2) {
      this.hesapla();
    }
    this.CD.detectChanges();
  }

  /**
   * 🎯 ÖLÇÜM MODU TOGGLE: Seçim 2 için ölçüm modunu değiştir
   * Döngü: enKisaDuz -> enKisa -> merkez -> enUzak -> enUzakDuz -> enKisaDuz
   * Sadece Seçim 2'yi değiştirir, Seçim 1'i değiştirmez
   */
  toggleSecim2OlcumModu(): void {
    // 🎯 DÜZLEM YÜZEY: Düzlem yüzeylerde "merkez" modu anlamsız, atla
    const duzlemMi = this.secim2MerkezBilgisi?.tip === 'duzlem';
    const modSirasi: Array<'enKisa' | 'enKisaDuz' | 'merkez' | 'enUzak' | 'enUzakDuz'> = duzlemMi
      ? ['enKisaDuz', 'enKisa', 'enUzak', 'enUzakDuz'] // Düzlemde merkez yok
      : ['enKisaDuz', 'enKisa', 'merkez', 'enUzak', 'enUzakDuz'];
    const mevcutIndex = modSirasi.indexOf(this.secim2OlcumModu);
    const yeniIndex = (mevcutIndex + 1) % modSirasi.length;
    const yeniMod = modSirasi[yeniIndex];
    // 🎯 Sadece Seçim 2'yi değiştir (Seçim 1'i değiştirme!)
    this.secim2OlcumModu = yeniMod;
    // 🎯 LocalStorage'a varsayılan mod olarak kaydet (sonraki YENİ seçimler için)
    this.kaydetOlcumModu(yeniMod);
    // Cache'i temizle ve yeniden hesapla
    this.cacheiTemizle();
    if (this.secilen1 && this.secilen2) {
      this.hesapla();
    }
    this.CD.detectChanges();
  }

  /**
   * 🎯 ÖLÇÜM MODU GERİ: Seçim 1 için önceki moda git (sağ tık)
   */
  toggleSecim1OlcumModuGeri(event: Event): void {
    event.preventDefault(); // Sağ tık menüsünü engelle
    const duzlemMi = this.secim1MerkezBilgisi?.tip === 'duzlem';
    const modSirasi: Array<'enKisa' | 'enKisaDuz' | 'merkez' | 'enUzak' | 'enUzakDuz'> = duzlemMi
      ? ['enKisaDuz', 'enKisa', 'enUzak', 'enUzakDuz']
      : ['enKisaDuz', 'enKisa', 'merkez', 'enUzak', 'enUzakDuz'];
    const mevcutIndex = modSirasi.indexOf(this.secim1OlcumModu);
    // Geri git (negatif index için modulo düzeltme)
    const yeniIndex = (mevcutIndex - 1 + modSirasi.length) % modSirasi.length;
    const yeniMod = modSirasi[yeniIndex];
    this.secim1OlcumModu = yeniMod;
    this.kaydetOlcumModu(yeniMod);
    this.cacheiTemizle();
    if (this.secilen1 && this.secilen2) {
      this.hesapla();
    }
    this.CD.detectChanges();
  }

  /**
   * 🎯 ÖLÇÜM MODU GERİ: Seçim 2 için önceki moda git (sağ tık)
   */
  toggleSecim2OlcumModuGeri(event: Event): void {
    event.preventDefault(); // Sağ tık menüsünü engelle
    const duzlemMi = this.secim2MerkezBilgisi?.tip === 'duzlem';
    const modSirasi: Array<'enKisa' | 'enKisaDuz' | 'merkez' | 'enUzak' | 'enUzakDuz'> = duzlemMi
      ? ['enKisaDuz', 'enKisa', 'enUzak', 'enUzakDuz']
      : ['enKisaDuz', 'enKisa', 'merkez', 'enUzak', 'enUzakDuz'];
    const mevcutIndex = modSirasi.indexOf(this.secim2OlcumModu);
    // Geri git (negatif index için modulo düzeltme)
    const yeniIndex = (mevcutIndex - 1 + modSirasi.length) % modSirasi.length;
    const yeniMod = modSirasi[yeniIndex];
    this.secim2OlcumModu = yeniMod;
    this.kaydetOlcumModu(yeniMod);
    this.cacheiTemizle();
    if (this.secilen1 && this.secilen2) {
      this.hesapla();
    }
    this.CD.detectChanges();
  }

  // Eski toggle metodları (geriye uyumluluk)
  toggleSecim1MerkezModu(): void { this.toggleSecim1OlcumModu(); }
  toggleSecim2MerkezModu(): void { this.toggleSecim2OlcumModu(); }

  /**
   * 🎯 ÖLÇÜM MODU KAYDET: LocalStorage'a varsayılan ölçüm modunu kaydet
   * Bu mod sonraki YENİ seçimlerde kullanılacak
   */
  private kaydetOlcumModu(mod: 'enKisa' | 'enKisaDuz' | 'merkez' | 'enUzak' | 'enUzakDuz'): void {
    try {
      const kaydedilen = localStorage.getItem('FikoYTOlcumAyarlari');
      const ayarlar = kaydedilen ? JSON.parse(kaydedilen) : {};
      // 🎯 Verilen modu varsayılan olarak kaydet
      ayarlar.varsayilanOlcumModu = mod;
      localStorage.setItem('FikoYTOlcumAyarlari', JSON.stringify(ayarlar));
    } catch (e) {
      // localStorage hatası - sessizce geç
    }
  }
  // Eski metod (geriye uyumluluk)
  private kaydetMerkezModu(): void { this.kaydetOlcumModu(this.secim1OlcumModu); }

  /**
   * 🎯 ÖLÇÜM MODU AL: LocalStorage'dan varsayılan ölçüm modunu al
   */
  private getVarsayilanOlcumModu(): 'enKisa' | 'enKisaDuz' | 'merkez' | 'enUzak' | 'enUzakDuz' {
    try {
      const kaydedilen = localStorage.getItem('FikoYTOlcumAyarlari');
      if (kaydedilen) {
        const ayarlar = JSON.parse(kaydedilen);
        // Yeni format
        if (ayarlar.varsayilanOlcumModu !== undefined) {
          return ayarlar.varsayilanOlcumModu;
        }
        // Eski format (boolean) için geriye uyumluluk
        if (ayarlar.varsayilanMerkezModu !== undefined) {
          return ayarlar.varsayilanMerkezModu ? 'merkez' : 'enKisaDuz';
        }
      }
    } catch (e) {
      // localStorage hatası
    }
    return 'enKisaDuz'; // Varsayılan: En Kısa Düz (CATIA style)
  }
  // Eski metod (geriye uyumluluk)
  private getVarsayilanMerkezModu(): boolean {
    return this.getVarsayilanOlcumModu() === 'merkez';
  }

  /**
   * 🎯 ÖLÇÜM MODU LABEL: UI'da gösterilecek mod etiketi
   */
  getOlcumModuLabel(mod: 'enKisa' | 'enKisaDuz' | 'merkez' | 'enUzak' | 'enUzakDuz'): string {
    switch (mod) {
      case 'enKisaDuz': return '⊥ Kısa Düz';
      case 'enKisa': return '↔ En Kısa';
      case 'merkez': return '⊙ Merkez';
      case 'enUzak': return '⤢ En Uzak';
      case 'enUzakDuz': return '⇕ Uzak Düz';
      default: return '⊥ Kısa Düz';
    }
  }

  // Yüzey tipi tespiti ve bilgi depolama
  yuzeyTipiTespitVeDepo(geom: THREE.BufferGeometry | undefined, secilisIndeks: 1 | 2): void {
    if (!geom) {
      if (secilisIndeks === 1) {
        this.yuzey1TipiInfo = null;
      } else {
        this.yuzey2TipiInfo = null;
      }
      return;
    }

    try {
      const tipiInfo = this.geomService.yuzeyTipiTespiti(geom);

      if (secilisIndeks === 1) {
        this.yuzey1TipiInfo = tipiInfo;
      } else {
        this.yuzey2TipiInfo = tipiInfo;
      }
    } catch (e) {
      if (secilisIndeks === 1) {
        this.yuzey1TipiInfo = null;
      } else {
        this.yuzey2TipiInfo = null;
      }
    }
  }

  /**
   * 🎯 GD&T: seçime göre 3D FCF sembolü göster.
   * Tek yüzey → form (düzlem=düzlemsellik, silindir=silindiriklik).
   * İki yüzey → yönelim (paralellik / diklik / açısallık — yüzey normalleri arası açıya göre).
   * Hover hot-path DEĞİL (seçim sonrası bir kez) → donma riski yok.
   */
  private gdtGuncelle(): void {
    try {
      const t1 = this.sonuc1Tipi, t2 = this.sonuc2Tipi;
      const g1 = this.secilen1Geom, g2 = this.secilen2Geom;
      const a1 = this.secim1MerkezBilgisi?.merkez as THREE.Vector3 | undefined;
      const a2 = this.secim2MerkezBilgisi?.merkez as THREE.Vector3 | undefined;

      // İKİ YÜZEY → yönelim toleransı
      if (t1 === 'Yüzey' && t2 === 'Yüzey' && g1 && g2 && a1 && a2) {
        const p1 = bestFitPlane(g1), p2 = bestFitPlane(g2);
        if (p1 && p2) {
          const dot = Math.min(1, Math.abs(p1.normal.dot(p2.normal)));
          const aci = Math.acos(dot) * 180 / Math.PI; // 0..90
          const tip: 'paralellik' | 'diklik' | 'acisallik' = aci < 15 ? 'paralellik' : (aci > 75 ? 'diklik' : 'acisallik');
          const g = yonelimSapma(g1, g2, tip, { nominalAci: tip === 'acisallik' ? aci : undefined });
          if (g) {
            const sym = tip === 'diklik' ? GDT_SEMBOL.diklik : (tip === 'paralellik' ? GDT_SEMBOL.paralellik : GDT_SEMBOL.acisallik);
            const anchor = a1.clone().add(a2).multiplyScalar(0.5);
            this.gdtAnnotator.goster([{ symbolType: sym, tolerance: g.sapma, attachPoint: anchor }]);
            return;
          }
        }
      }

      // TEK YÜZEY → form toleransı (yalnız 1. seçim yüzey, 2. seçim henüz yok)
      if (t1 === 'Yüzey' && g1 && a1 && !this.secilen2) {
        const silindirMi = (this.yuzey1TipiInfo as any)?.tip === 'silindir';
        const g: any = silindirMi ? cylindricity(g1) : flatness(g1);
        if (g) {
          const sym = silindirMi ? GDT_SEMBOL.silindiriklik : GDT_SEMBOL.flatness;
          this.gdtAnnotator.goster([{ symbolType: sym, tolerance: g.sapma, attachPoint: a1.clone() }]);
          return;
        }
      }

      this.gdtAnnotator.temizle();
    } catch { this.gdtAnnotator.temizle(); }
  }

  async baslat(anaGosterim: FikoThreeJsComponent) {
    this.bitir();
    this.anaGosterim = anaGosterim;

    // 🎯 SESSION ID: Her dialog açılışında benzersiz ID üret
    this.sessionId = this.generateSessionId();

    // 🚀 GPU Ölçüm Motoru'nu başlat
    if (this.anaGosterim?.sunucu) {
      await gpuOlcumMotoru.initialize(this.anaGosterim.sunucu);
      // 🚀 Scene'i GPU için optimize et (BVH raycasting)
      gpuOlcumMotoru.optimizeScene(this.anaGosterim.sahneler[0]);
    }

    // GPU mode'u al ve göster
    this.gpuStats = gpuOlcumMotoru.getPerformanceStats();
    this.gpuMode = this.gpuStats.mode;

    // 🎯 KALICI ÖLÇÜMLER: FikoKaynakca altındaki kalıcı ölçümler grubunu bul
    const sahneFiko = this.anaGosterim.sahneler[0] as any;
    this.kaliciOlcumlerGrubuBul(sahneFiko);

    // FikoOlcumler grubu oluştur veya var olanı bul (geçici ölçümler için)
    this.fikoOlcumlerGrubu = sahneFiko.getObjectByName('Ölçümler') as FikoOlcumler;

    if (!this.fikoOlcumlerGrubu) {
      this.fikoOlcumlerGrubu = new FikoOlcumler((sahneFiko.sahne || undefined) as any);
      sahneFiko.add(this.fikoOlcumlerGrubu);
    }

    // FikoSahne'deki tek instance'ı kullan - çift seçim modunda
    this.fikoSecim1 = this.anaGosterim.sahneler[0].secimler;
    // 🎯 ARAÇ STATE YEDEK: araç kapanınca bitir() geri yükler (araçlar arası karışma fix)
    this.fikoSecim1.durumYedekle?.();
    this._secimDurumYedekli = true;
    this.fikoSecim1.ciftSecimModu = true; // Çift seçim modunu aktif et
    this.fikoSecim1.aktifSecim = 1; // İlk seçim aktif
    this.fikoSecim1.temizle(); // Önceki highlight'ları temizle
    this.fikoSecim1.aktif = true;
    // 🎯 KALICI SEÇİM: Seçimler yeni seçim yapılana kadar highlight olarak kalır
    this.fikoSecim1.kaliciSecimModu = true;
    // 🎯 HOVER HIGHLIGHT: Ayarlardan yükle (geçiş sorununu çözer)
    this.hoverAyarlariYukle();

    // 🚀🚀🚀 WEBGPU ULTRA HIZLI MOD - Tüm eski sistemler kapalı
    // Piksel tabanlı seçim kapalı - GPU tabanlı seçim aktif
    this.fikoSecim1.pikselTabanliSecimAktif = false;
    this.fikoSecim1.edgeSelectionEnabled = false;
    this.fikoSecim1.pointSelectionEnabled = false;
    this.fikoSecim1.smartPriorityEnabled = false;
    this.fikoSecim1.edgeSelectionPriority = false;
    // 🚀 GPU Picking her zaman aktif
    this.fikoSecim1.useGPUPicking = true;
    // 🚀 Throttle yok - anında yanıt
    (this.fikoSecim1 as any).highlightThrottleMs = 0;

    // 🎯 HIGHLIGHT RENKLERİ: FikoThreeJSAyarlari'ndan yükle
    // Yüzey highlight renkleri
    const hoverRenk = parseInt(this.hoverRengi.replace('#', ''), 16);
    const secilmisRenk = parseInt(this.secilmisRengi.replace('#', ''), 16);
    this.fikoSecim1.hoverColor = new THREE.Color(hoverRenk);
    this.fikoSecim1.selectedColor = new THREE.Color(secilmisRenk);
    this.fikoSecim1.hoverOpacity = this.hoverOpacity;
    this.fikoSecim1.selectedOpacity = this.secilmisOpacity;
    // Çizgi highlight renkleri
    const cizgiHoverRenk = parseInt(this.cizgiHoverRengi.replace('#', ''), 16);
    const cizgiSecilmisRenk = parseInt(this.cizgiSecilmisRengi.replace('#', ''), 16);
    this.fikoSecim1.cizgiHoverColor = new THREE.Color(cizgiHoverRenk);
    this.fikoSecim1.cizgiSecilmisColor = new THREE.Color(cizgiSecilmisRenk);
    this.fikoSecim1.cizgiKalinligi = this.cizgiHighlightKalinligi;
    // Material ayarları
    this.fikoSecim1.highlightSaydamlik = this.highlightSaydamlik;

    // İkinci seçim için aynı instance'ı kullanacağız
    this.fikoSecim2 = this.anaGosterim.sahneler[0].secimler;

    // 🎯 YENİ DIMENSION SİSTEMİ: Servisi başlat
    if (this.useNewDimensionSystem) {
      this.initDimensionService();
    }

    this.fikoSecimOlaylarTanit();
    //@ts-ignore
    document.body.style.cursor = "url('/cursor/cetvel-bos.webp'), auto";

  }

  /**
   * 🎯 YENİ DIMENSION SİSTEMİ: DimensionIntegrationService'i başlat
   */
  private initDimensionService(): void {
    if (!this.anaGosterim?.sahneler[0]) return;

    const fikoSahne = this.anaGosterim.sahneler[0];
    this.dimensionService = new DimensionIntegrationService();
    this.dimensionService.initialize(fikoSahne, this.fikoOlcumlerGrubu);
    this.gdtAnnotator.setGrup(this.fikoOlcumlerGrubu as any); // GD&T FCF sembolleri bu gruba eklenir

    // Ayarları uygula
    this.dimensionService.updateSettings({
      birim: this.secilenBirim,
      hassasiyet: this.mesafeBas,
      siyahStil: true
    });

    // 🎯 v3.2.10: SÜRÜKLEME DESTEĞİNİ AKTİF ET
    const canvas = this.anaGosterim?.sunucu?.domElement;
    if (canvas) {
      const manager = this.dimensionService.getManager();
      if (manager) {
        manager.enableDragSupport(canvas);
        // console.log('[Cetvel] v3.2.10 Sürükleme desteği aktif edildi');
      }
    }
  }

  // ==========================================
  // 🎯 BREP CURSOR SİSTEMİ
  // Surface/Edge type'a göre cursor simgesi değiştirme
  // ==========================================

  /**
   * 🎯 BREP CURSOR: Surface type'a göre cursor'u güncelle
   * PLANE → cetvel-yuzey-duzlem
   * CYLINDER/SPHERE/CONE/TORUS → cetvel-yuzey-dairesel
   * BSPLINE/BEZIER/OTHER → cetvel-yuzey-dalgali
   * LINE → cetvel-cizgi-duz
   * CIRCLE → cetvel-cizgi-dairesel
   */
  private cursorGuncelle(kesisim: any, secimNo: 1 | 2 = 1): void {
    const fikoSecim = secimNo === 1 ? this.fikoSecim1 : this.fikoSecim2;

    if (!fikoSecim?.hoverHighlightEnabled) {
      // Hover kapalıysa varsayılan cursor
      if (this.sonCursor !== this.varsayilanCursor) {
        document.body.style.cursor = this.varsayilanCursor;
        this.sonCursor = this.varsayilanCursor;
      }
      return;
    }

    if (!kesisim || !kesisim.object) {
      // Kesişim yoksa varsayılan cursor
      if (this.sonCursor !== this.varsayilanCursor) {
        document.body.style.cursor = this.varsayilanCursor;
        this.sonCursor = this.varsayilanCursor;
      }
      return;
    }

    let yeniCursor = this.varsayilanCursor;
    const altObje = (kesisim as any).altObje;
    const obj = kesisim.object;

    // Nesne tipine göre cursor belirle
    // ÖNCELİK: Çizgi > Nokta > Yüzey (altObje öncelikli)
    if (altObje?.type === 'LineSegments' || altObje?.type === 'LineSegments2' ||
        altObje?.type === 'Line2' || altObje?.type === 'Line') {
      // ÇİZGİ - altObje çizgi ise
      yeniCursor = this.cizgiIcinCursorBelirle(kesisim, secimNo);
    } else if (obj?.type === 'LineSegments' || obj?.type === 'LineSegments2' ||
               obj?.type === 'Line2' || obj?.type === 'Line') {
      // ÇİZGİ - obj çizgi ise
      yeniCursor = this.cizgiIcinCursorBelirle(kesisim, secimNo);
    } else if (altObje?.type === 'Points' || obj?.type === 'Points') {
      // NOKTA - SVG cursor kullan
      yeniCursor = this.SVG_CURSORS.nokta;
    } else if (altObje?.type === 'Mesh' || obj?.type === 'Mesh' || obj?.type === 'FikoCizimYalin') {
      // YÜZEY - Surface type'a göre cursor
      yeniCursor = this.yuzeyIcinCursorBelirle(kesisim, secimNo);
    }

    // Cursor değiştiyse güncelle
    if (this.sonCursor !== yeniCursor) {
      document.body.style.cursor = yeniCursor;
      this.sonCursor = yeniCursor;
    }
  }

  /**
   * 🎯 YÜZEY CURSOR: Surface type'a göre cursor belirle
   * FikoSecililer'den gelen hover highlight'ın grup bilgisini kullanır
   */
  private yuzeyIcinCursorBelirle(kesisim: any, secimNo: 1 | 2 = 1): string {
    const fikoSecim = secimNo === 1 ? this.fikoSecim1 : this.fikoSecim2;
    // 🎯 FIX: FikoSecililer'in sonSecilenGrupId'sini kullan (hover için doğru grup)
    const grpId = fikoSecim?.sonSecilenGrupIdUzerinde ?? -1;

    // 1. occt_faceGroups'tan surface type al
    const cizim = kesisim.object;
    const faceGroups = cizim?.occt_faceGroups || (cizim?.parent as any)?.occt_faceGroups;

    if (faceGroups && Array.isArray(faceGroups) && grpId >= 0 && grpId < faceGroups.length) {
      const faceInfo = faceGroups[grpId];
      const surfaceType = faceInfo?.surfaceType || faceInfo?.underlyingType;

      if (surfaceType) {
        return this.surfaceTypeToCursor(surfaceType);
      }
    }

    // 2. Fallback: kesisim.faceIndex'ten hesapla
    if (faceGroups && Array.isArray(faceGroups)) {
      const mesh = (kesisim as any).altObje || kesisim.object;
      const geom = mesh?.geometry || cizim?.meshGeom;

      if (geom?.attributes?.grup && kesisim.faceIndex !== undefined) {
        const grupAttr = geom.attributes.grup;
        const vertexIdx = kesisim.faceIndex * 3;
        if (vertexIdx < grupAttr.count) {
          const fallbackGrpId = grupAttr.getZ(vertexIdx);

          if (fallbackGrpId >= 0 && fallbackGrpId < faceGroups.length) {
            const faceInfo = faceGroups[fallbackGrpId];
            const surfaceType = faceInfo?.surfaceType || faceInfo?.underlyingType;

            if (surfaceType) {
              return this.surfaceTypeToCursor(surfaceType);
            }
          }
        }
      }

      // 3. Geometry attribute'undan surface type al
      if (geom?.attributes?.surfaceType && kesisim.faceIndex !== undefined) {
        const surfaceTypeAttr = geom.attributes.surfaceType;
        const vertexIdx = kesisim.faceIndex * 3;
        if (vertexIdx < surfaceTypeAttr.count) {
          const surfaceTypeCode = surfaceTypeAttr.getX(vertexIdx);
          return this.surfaceTypeCodeToCursor(surfaceTypeCode);
        }
      }
    }

    // Varsayılan yüzey cursor - SVG
    return this.SVG_CURSORS.yuzeyDuzlem;
  }

  /**
   * 🎯 ÇİZGİ CURSOR: Çizgi tipine göre cursor belirle (BREP curveType öncelikli)
   */
  private cizgiIcinCursorBelirle(kesisim: any, secimNo: 1 | 2 = 1): string {
    const fikoSecim = secimNo === 1 ? this.fikoSecim1 : this.fikoSecim2;
    // 1. BREP curveType bilgisini dene (en doğru yöntem)
    const edgeGrupId = fikoSecim?.sonSecilenEdgeGrupIdUzerinde ?? -1;

    // FikoCizimYalin VEYA occt metadata taşıyan modelleme gövdesini bul
    let cizim = kesisim.object;
    while (cizim && cizim.type !== 'FikoCizimYalin' && !(cizim as any).occt_edgeGroups) {
      cizim = cizim.parent;
    }

    // occt_edgeGroups metadata'sını kontrol et
    const edgeGroups = (cizim as any)?.occt_edgeGroups;

    if (edgeGrupId >= 0 && edgeGroups && edgeGrupId < edgeGroups.length) {
      const curveType = edgeGroups[edgeGrupId]?.curveType;
      if (curveType) {
        return this.curveTypeToCursor(curveType);
      }
    }

    // 2. Fallback: Geometri analizi ile eğrilik tespiti
    const secilen = (kesisim as any).altObje || kesisim.object;
    if (!secilen?.geometry) {
      return this.SVG_CURSORS.cizgiDuz;
    }

    // Highlight geometrisini kullan (daha doğru)
    const geom = fikoSecim?.sonSecilenHighlightGeometri || secilen.geometry;
    const posAttr = geom?.attributes?.position;

    if (posAttr && posAttr.count >= 3) {
      // Basit eğrilik tespiti: vertex'ler arasındaki açı değişimi
      const v1 = new THREE.Vector3(posAttr.getX(0), posAttr.getY(0), posAttr.getZ(0));
      const v2 = new THREE.Vector3(posAttr.getX(Math.floor(posAttr.count / 2)), posAttr.getY(Math.floor(posAttr.count / 2)), posAttr.getZ(Math.floor(posAttr.count / 2)));
      const v3 = new THREE.Vector3(posAttr.getX(posAttr.count - 1), posAttr.getY(posAttr.count - 1), posAttr.getZ(posAttr.count - 1));

      const dir1 = v2.clone().sub(v1).normalize();
      const dir2 = v3.clone().sub(v2).normalize();
      const dot = dir1.dot(dir2);

      if (dot < 0.99) {
        // Eğri çizgi - dairesel veya dalgalı
        // miCember kontrolü ile tam çember mi kontrol et
        const miCem = miCember(geom);
        if (miCem && miCem.yaricap > 0.1) {
          return this.SVG_CURSORS.cizgiDairesel;
        }
        return this.SVG_CURSORS.cizgiDalgali;
      }
    }

    // Düz çizgi - SVG cursor
    return this.SVG_CURSORS.cizgiDuz;
  }

  /**
   * Curve type string'den SVG cursor'a çevir
   */
  private curveTypeToCursor(curveType: string): string {
    switch (curveType?.toUpperCase()) {
      case 'LINE':
        return this.SVG_CURSORS.cizgiDuz;
      case 'CIRCLE':
      case 'ELLIPSE':
        return this.SVG_CURSORS.cizgiDairesel;
      case 'BSPLINE':
      case 'BEZIER':
      case 'HYPERBOLA':
      case 'PARABOLA':
      case 'OFFSET':
      case 'OTHER':
      default:
        return this.SVG_CURSORS.cizgiDalgali;
    }
  }

  /**
   * Surface type string'den SVG cursor'a çevir
   */
  private surfaceTypeToCursor(surfaceType: string): string {
    switch (surfaceType?.toUpperCase()) {
      case 'PLANE':
        return this.SVG_CURSORS.yuzeyDuzlem;
      case 'CYLINDER':
      case 'SPHERE':
      case 'CONE':
      case 'TORUS':
        return this.SVG_CURSORS.yuzeyDairesel;
      case 'BSPLINE':
      case 'BEZIER':
      case 'REVOLUTION':
      case 'EXTRUSION':
      case 'OFFSET':
      case 'OTHER':
      default:
        return this.SVG_CURSORS.yuzeyDalgali;
    }
  }

  /**
   * Surface type code'dan SVG cursor'a çevir
   * 0=UNKNOWN, 1=PLANE, 2=CYLINDER, 3=SPHERE, 4=CONE, 5=TORUS, 6=BEZIER, 7=BSPLINE, 8=REVOLUTION, 9=EXTRUSION, 10=OFFSET, 11=OTHER
   */
  private surfaceTypeCodeToCursor(code: number): string {
    switch (code) {
      case 1: // PLANE
        return this.SVG_CURSORS.yuzeyDuzlem;
      case 2: // CYLINDER
      case 3: // SPHERE
      case 4: // CONE
      case 5: // TORUS
        return this.SVG_CURSORS.yuzeyDairesel;
      case 6: // BEZIER
      case 7: // BSPLINE
      case 8: // REVOLUTION
      case 9: // EXTRUSION
      case 10: // OFFSET
      case 11: // OTHER
      case 0: // UNKNOWN
      default:
        return this.SVG_CURSORS.yuzeyDalgali;
    }
  }

  fikoSecimOlaylarTanit() {
    // 🎯 HOVER EVENT - Secim 1: Tüm modlarda hover highlight + Nokta Koy modunda mouse ile hareket eden nokta göster
    this.subsList.push(
      this.fikoSecim1.uzerinde.subscribe((kesisim) => {
        // 🎯 BREP CURSOR: Surface/Edge type'a göre cursor güncelle
        this.cursorGuncelle(kesisim, 1);

        // 🎯 AKILLI ÇAP: dairesel kenar hover'da çapı önizle (donmasız: kenar değişince + metadata)
        this.akilliCapOnizle(kesisim);

        // 🎯 NOKTA KOY MODU: Yüzey highlight'ları yapma, sadece hover noktası göster
        const noktaKoyModu1 = Array.isArray(this.secim1Filitre) && this.secim1Filitre.indexOf("Nokta Koy") > -1;

        if (noktaKoyModu1 && this.fikoSecim1.aktifSecim === 1) {
          this.cemberPreviewGizle();
          // Nokta Koy modunda yüzey highlight'larını temizle
          if (this.fikoSecim1.grupSecimlerUzerinde) {
            this.fikoSecim1.grupSecimlerUzerinde.clear();
          }

          if (!kesisim || !kesisim.point) {
            this.hoverNoktaTemizle(1);
            this.throttledCiz();
            return;
          }

          // 🎯 SON GEÇERLİ KESİŞİM: Hızlı tıklamada doğru pozisyon için sakla
          this.sonGecerliKesisim1 = kesisim;

          // ⚡ GEOMETRIC SNAP: Snap uygula (vertex/endpoint/midpoint/center/edge)
          const snapResult1 = this.applySnap(kesisim.point, kesisim);
          const snapKonum1 = snapResult1.snapped ? snapResult1.position : kesisim.point;

          // Hover noktasını göster/güncelle (mouse ile hareket eder) - CATIA-style
          this.hoverNoktaGoster(snapKonum1, kesisim, 1);
          return;
        }

        // 🎯 GENEL HOVER HIGHLIGHT: Diğer modlar için çalışır
        if (kesisim && this.fikoSecim1.grupSecimlerUzerinde) {
          this.throttledCiz();
        } else if (this.fikoSecim1.grupSecimlerUzerinde) {
          this.fikoSecim1.grupSecimlerUzerinde.clear();
          this.throttledCiz();
        }

        // Nokta Koy modunda değilsek hover noktasını temizle
        this.hoverNoktaTemizle(1);
      })
    );

    // 🎯 HOVER EVENT - Secim 2: Tüm modlarda hover highlight + Nokta Koy modunda mouse ile hareket eden nokta göster
    this.subsList.push(
      this.fikoSecim2.uzerinde.subscribe((kesisim) => {
        // 🎯 BREP CURSOR: Surface/Edge type'a göre cursor güncelle
        this.cursorGuncelle(kesisim, 2);

        // 🎯 AKILLI ÇAP: dairesel kenar hover'da çapı önizle
        this.akilliCapOnizle(kesisim);

        // 🎯 NOKTA KOY MODU: Yüzey highlight'ları yapma, sadece hover noktası göster
        const noktaKoyModu2 = Array.isArray(this.secim2Filitre) && this.secim2Filitre.indexOf("Nokta Koy") > -1;

        if (noktaKoyModu2 && this.fikoSecim1.aktifSecim === 2) {
          this.cemberPreviewGizle();
          // Nokta Koy modunda yüzey highlight'larını temizle
          if (this.fikoSecim2.grupSecimlerUzerinde) {
            this.fikoSecim2.grupSecimlerUzerinde.clear();
          }

          if (!kesisim || !kesisim.point) {
            this.hoverNoktaTemizle(2);
            this.throttledCiz();
            return;
          }

          // 🎯 SON GEÇERLİ KESİŞİM: Hızlı tıklamada doğru pozisyon için sakla
          this.sonGecerliKesisim2 = kesisim;

          // ⚡ GEOMETRIC SNAP: Snap uygula (vertex/endpoint/midpoint/center/edge)
          const snapResult2 = this.applySnap(kesisim.point, kesisim);
          const snapKonum2 = snapResult2.snapped ? snapResult2.position : kesisim.point;

          // Hover noktasını göster/güncelle (mouse ile hareket eder) - CATIA-style
          this.hoverNoktaGoster(snapKonum2, kesisim, 2);
          return;
        }

        // 🎯 GENEL HOVER HIGHLIGHT: Diğer modlar için çalışır
        if (kesisim && this.fikoSecim2.grupSecimlerUzerinde) {
          this.throttledCiz();
        } else if (this.fikoSecim2.grupSecimlerUzerinde) {
          this.fikoSecim2.grupSecimlerUzerinde.clear();
          this.throttledCiz();
        }

        // ⚡ LIVE PREVIEW: İlk seçim yapılmış ama ikinci henüz yapılmamışsa
        // hover noktasına kesikli çizgi + mesafe etiketi göster
        if (this.secilen1?.point && !this.secilen2 && kesisim?.point) {
          // ⚡ GEOMETRIC SNAP: Preview'da da snap uygula
          const previewSnap = this.applySnap(kesisim.point, kesisim);
          const previewKonum = previewSnap.snapped ? previewSnap.position : kesisim.point;
          this.previewGoster(this.secilen1.point, previewKonum);
        } else {
          this.previewGizle();
        }

        // Nokta Koy modunda değilsek hover noktasını temizle
        this.hoverNoktaTemizle(2);
      })
    );

    this.subsList.push(
      this.fikoSecim1.tiklandi1.subscribe(val => {
        if (val) {
          // Async olarak işle - böylece emit tamamlandıktan sonra aktifSecim değişir
          setTimeout(() => {
            // 🎯 NOKTA KOY MODU: Seçim highlight'larını yapma, sadece noktayı koy
            const noktaKoyModu1 = Array.isArray(this.secim1Filitre) && this.secim1Filitre.indexOf("Nokta Koy") > -1;

            if (noktaKoyModu1) {
              // Nokta Koy modunda tüm highlight'ları temizle
              if (this.fikoSecim1.grupSecimler) {
                this.fikoSecim1.grupSecimler.clear();
              }
              if (this.fikoSecim1.grupSecimlerUzerinde) {
                this.fikoSecim1.grupSecimlerUzerinde.clear();
              }
            }

            // 🎯 YENİ ÖLÇÜM: Gösterimi ve kalıcı noktaları temizle
            // NOT: grupSecimler.clear() YAPMA! pointerUp'ta kesisimCozumle() highlight ekledikten SONRA
            // bu callback çağrılıyor, clear() yaparsak az eklenen highlight silinir!
            // 🎯 GÜNCELLEME: Nokta Koy modunda yukarıda temizleniyor
            this.kaliciNoktalariTemizle();
            this.gosterimYukleTemizle();

            // 🎯 NOKTA KOY: Tıklandığında kalıcı nokta ekle (yüzeye project edilmiş)
            // 🎯 HIZLI TIKLAMA FIX: Son geçerli kesişimi kullan (val yetersiz olabilir)
            if (noktaKoyModu1) {
              const kesisimKullan = this.sonGecerliKesisim1 || val;
              if (kesisimKullan?.point) {
                // ⚡ GEOMETRIC SNAP: Tıklamada snap uygula
                const clickSnap1 = this.applySnap(kesisimKullan.point, kesisimKullan);
                const snapPos1 = clickSnap1.snapped ? clickSnap1.position : kesisimKullan.point;
                this.kaliciNoktaEkle(snapPos1, 'Nokta 1', kesisimKullan);
              }
              // Kullanılan kesişimi sonuc1TipBelirle'ye de geçir
              this.sonuc1TipBelirle(kesisimKullan);
              // Kesişimi sıfırla (bir sonraki seçim için)
              this.sonGecerliKesisim1 = null;
            } else {
              this.sonuc1TipBelirle(val);
            }
            /** */
            this.sonuc = null;
            this.secilen2 = null;
            this.sonuc2Tipi = null;
            this.secilen2Geom = null;
            this.yuzey2TipiInfo = null;
            /** */

            // Aktif seçimi 2'ye çevir
            this.fikoSecim1.aktifSecim = 2;
            this.fikoSecim2.rayObje = this.anaGosterim.sahneler[0].children;
          }, 0);
        }
      })
    );

    this.subsList.push(
      this.fikoSecim2.tiklandi2.subscribe(val => {
        if (val) {
          // Async olarak işle - böylece emit tamamlandıktan sonra aktifSecim değişir
          setTimeout(() => {
            // 🎯 NOKTA KOY MODU: Seçim highlight'larını yapma, sadece noktayı koy
            const noktaKoyModu2 = Array.isArray(this.secim2Filitre) && this.secim2Filitre.indexOf("Nokta Koy") > -1;

            if (noktaKoyModu2) {
              // Nokta Koy modunda tüm highlight'ları temizle (seçim 2 için grupSecimler2)
              if (this.fikoSecim2.grupSecimler2) {
                this.fikoSecim2.grupSecimler2.clear();
              }
              if (this.fikoSecim2.grupSecimlerUzerinde) {
                this.fikoSecim2.grupSecimlerUzerinde.clear();
              }
            }

            // 🎯 NOKTA KOY: Tıklandığında kalıcı nokta ekle (yüzeye project edilmiş)
            // 🎯 HIZLI TIKLAMA FIX: Son geçerli kesişimi kullan (val yetersiz olabilir)
            if (noktaKoyModu2) {
              const kesisimKullan = this.sonGecerliKesisim2 || val;
              if (kesisimKullan?.point) {
                // ⚡ GEOMETRIC SNAP: Tıklamada snap uygula
                const clickSnap2 = this.applySnap(kesisimKullan.point, kesisimKullan);
                const snapPos2 = clickSnap2.snapped ? clickSnap2.position : kesisimKullan.point;
                this.kaliciNoktaEkle(snapPos2, 'Nokta 2', kesisimKullan);
              }
              // Kullanılan kesişimi sonuc2TipBelirle'ye de geçir
              this.sonuc2TipBelirle(kesisimKullan);
              // Kesişimi sıfırla (bir sonraki seçim için)
              this.sonGecerliKesisim2 = null;
            } else {
              this.sonuc2TipBelirle(val); // İçinde zaten hesapla() çağrılıyor
            }

            // Aktif seçimi 1'e geri çevir - bir sonraki ölçüm için hazır
            this.fikoSecim1.aktifSecim = 1;
          }, 0);
        }
      })
    );


  }

  async sonuc1TipBelirle(kesisim: any) {
    const result = this.selectionService.determineSonuc1Type(
      kesisim,
      this.secim1Filitre as string,
      this.fikoSecim1,
      (geom: THREE.BufferGeometry | undefined, index: 1 | 2) => {
        this.yuzeyTipiTespitVeDepo(geom, index);
      },
      (selection: any, lineSegments: THREE.LineSegments, kesisimArg?: any) => {
        return this.geomService.cizgiGeometriAlVeTransformUygula(selection, lineSegments, kesisimArg);
      }
    );

    this.sonuc1Tipi = result.tipi;
    this.secilen1 = result.secilen;
    this.secilen1Geom = result.secilenGeom;
    this.secilen1PointIndex = result.secilenPointIndex;

    // 🎯 MERKEZ BİLGİSİ TESPİTİ: Radiüslü yüzey/çizgi için merkez bilgisini tespit et
    this.secim1MerkezBilgisi = null;
    // 🎯 ÖLÇÜM MODU: Kaydedilen varsayılan değeri kullan (sıfırlama!)
    this.secim1OlcumModu = this.getVarsayilanOlcumModu();
    if (result.secilenGeom) {
      if (result.tipi === 'Yüzey') {
        // 🚀 ASYNC: Silindir/küre tespiti (donmadan hesaplama!)
        const calculationId = `surface1_${result.secilen?.uuid || Date.now()}`;
        const silindirBilgisi = await this.mathService.yuzeySilindirTespitAsync(result.secilenGeom, calculationId);
        if (silindirBilgisi) {
          // 🎯 DÜZELTME: Merkez noktasını WORLD KOORDİNATLARINA dönüştür
          // Yüzey geometrisi LOCAL space'de, merkez de LOCAL space'de hesaplandı
          const yuzeyMesh = (result.secilen?.altObje || result.secilen?.object) as THREE.Mesh;
          if (yuzeyMesh && yuzeyMesh.matrixWorld) {
            silindirBilgisi.merkez.applyMatrix4(yuzeyMesh.matrixWorld);
          }
          this.secim1MerkezBilgisi = silindirBilgisi;
        } else {
          // 🎯 DÜZLEM YÜZEY: Ağırlık merkezini kullan (ölçüm modları için)
          const agirlikMerkezi = this.geomService.agirlikMerkezi(result.secilenGeom);
          const yuzeyMesh = (result.secilen?.altObje || result.secilen?.object) as THREE.Mesh;
          if (yuzeyMesh && yuzeyMesh.matrixWorld) {
            agirlikMerkezi.applyMatrix4(yuzeyMesh.matrixWorld);
          }
          this.secim1MerkezBilgisi = { merkez: agirlikMerkezi, yaricap: 0, tip: 'duzlem' };
        }
      } else if (result.tipi === 'Çizgi') {
        // Çember/yay tespiti - Çizgi geometrisi zaten world space'de (cizgiGeometriAlVeTransformUygula)
        const cemberBilgisi = this.mathService.cizgiCemberTespit(result.secilenGeom);
        if (cemberBilgisi) {
          this.secim1MerkezBilgisi = cemberBilgisi;
        }
      }
    }

    // ✅ Cache'i temizle (seçim değiştiğinde)
    this.cacheiTemizle();

    // Change detection hatasını önlemek için async
    setTimeout(() => {
      this.gdtGuncelle(); // 🎯 tek yüzey → form GD&T sembolü
      this.CD.detectChanges();
    }, 0);
  }

  async sonuc2TipBelirle(kesisim: any) {
    const result = this.selectionService.determineSonuc2Type(
      kesisim,
      this.secim2Filitre as string,
      this.fikoSecim2,
      this.secilen1,
      this.secilen1?.faceIndex ?? null,
      (geom: THREE.BufferGeometry | undefined, index: 1 | 2) => {
        this.yuzeyTipiTespitVeDepo(geom, index);
      },
      (selection: any, lineSegments: THREE.LineSegments, kesisimArg?: any) => {
        return this.geomService.cizgiGeometriAlVeTransformUygula(selection, lineSegments, kesisimArg);
      }
    );

    if (result.tipi === null && this.secilen1?.object === kesisim?.object &&
        this.secilen1?.faceIndex === kesisim?.faceIndex) {
    }

    this.sonuc2Tipi = result.tipi;
    this.secilen2 = result.secilen;
    this.secilen2Geom = result.secilenGeom;
    this.secilen2PointIndex = result.secilenPointIndex;

    // 🎯 MERKEZ BİLGİSİ TESPİTİ: Radiüslü yüzey/çizgi için merkez bilgisini tespit et
    this.secim2MerkezBilgisi = null;
    // 🎯 ÖLÇÜM MODU: Kaydedilen varsayılan değeri kullan (sıfırlama!)
    this.secim2OlcumModu = this.getVarsayilanOlcumModu();
    if (result.secilenGeom) {
      if (result.tipi === 'Yüzey') {
        // 🚀 ASYNC: Silindir/küre tespiti (donmadan hesaplama!)
        const calculationId = `surface2_${result.secilen?.uuid || Date.now()}`;
        const silindirBilgisi = await this.mathService.yuzeySilindirTespitAsync(result.secilenGeom, calculationId);
        if (silindirBilgisi) {
          // 🎯 DÜZELTME: Merkez noktasını WORLD KOORDİNATLARINA dönüştür
          // Yüzey geometrisi LOCAL space'de, merkez de LOCAL space'de hesaplandı
          const yuzeyMesh = (result.secilen?.altObje || result.secilen?.object) as THREE.Mesh;
          if (yuzeyMesh && yuzeyMesh.matrixWorld) {
            silindirBilgisi.merkez.applyMatrix4(yuzeyMesh.matrixWorld);
          }
          this.secim2MerkezBilgisi = silindirBilgisi;
        } else {
          // 🎯 DÜZLEM YÜZEY: Ağırlık merkezini kullan (ölçüm modları için)
          const agirlikMerkezi = this.geomService.agirlikMerkezi(result.secilenGeom);
          const yuzeyMesh = (result.secilen?.altObje || result.secilen?.object) as THREE.Mesh;
          if (yuzeyMesh && yuzeyMesh.matrixWorld) {
            agirlikMerkezi.applyMatrix4(yuzeyMesh.matrixWorld);
          }
          this.secim2MerkezBilgisi = { merkez: agirlikMerkezi, yaricap: 0, tip: 'duzlem' };
        }
      } else if (result.tipi === 'Çizgi') {
        // Çember/yay tespiti - Çizgi geometrisi zaten world space'de (cizgiGeometriAlVeTransformUygula)
        const cemberBilgisi = this.mathService.cizgiCemberTespit(result.secilenGeom);
        if (cemberBilgisi) {
          this.secim2MerkezBilgisi = cemberBilgisi;
        }
      }
    }

    // ✅ Cache'i temizle (seçim değiştiğinde)
    this.cacheiTemizle();

    // Seçim 2 tamamlandı - change detection hatasını önlemek için async hesapla
    setTimeout(() => {
      this.hesapla();
      this.CD.detectChanges();
    }, 0);
  }


  async hesapla() {
    // ===== PERFORMANS: Seçim ve cache validation =====
    if (!this.secilen1 || !this.secilen2) {
      return;
    }

    // ===== PERFORMANS: Throttle - CATIA seviyesi akıcılık =====
    // Çok hızlı tıklamalarda hesaplamayı throttle et
    const now = performance.now();
    if (now - this.lastCalculationTime < 16) { // 60 FPS = 16ms
      return;
    }
    this.lastCalculationTime = now;

    // ===== PERFORMANS: Cache CHECK - %40-50 kazanç =====
    const cacheKey = this.olusturCacheAnahtarı();
    if (this.hesaplaCache.has(cacheKey)) {
      this.sonuc = this.hesaplaCache.get(cacheKey);
      this.CD.detectChanges();
      // 🔴 BUGFIX: Cache'den alınan sonuç için de render güncelle
      if (this.anaGosterim?.ciz) {
        this.anaGosterim.ciz();
      }
      return; // Matematik hesaplama tamamen atlandı!
    }

    // 🔴 Yeni ölçüm başlamadan önce önceki gösterimleri temizle
    this.gosterimYukleTemizle();

    // Tüm ölçüm hesaplamaları mathService.hesapla() ile yapılıyor
    this.sonuc = await this.mathService.hesapla(
      this.secilen1,
      this.secilen2,
      this.secilen1PointIndex,
      this.secilen2PointIndex,
      this.secilen1Geom,
      this.secilen2Geom,
      this.sonuc1Tipi,
      this.sonuc2Tipi,
      this.secim1Turu,
      this.secim2Turu,
      this.fikoSecim1,
      this.fikoSecim2,
      this.anaGosterim,
      0, // tolerans (varsayılan olarak 0)
      this.olcumGecmisi,
      (aciklama: string, olcu: number, birim: string, tip: string) =>
        this.olcumGecmisineEkle(aciklama, olcu, birim, tip),
      (nokta1: THREE.Vector3, nokta2: THREE.Vector3, label: string, isArc?: boolean, aci?: number, merkezNoktasi?: THREE.Vector3) =>
        this.gosterimKayniyaEkle(nokta1, nokta2, label, isArc, aci, merkezNoktasi),
      () => this.CD.detectChanges(),
      // 🔴 BUGFIX: Basamak sayıları
      this.mesafeBas,
      this.aciBasamak,
      // 🔴 BUGFIX: Birim ve dönüştürme
      this.secilenBirim,
      this.birimFaktore,
      // 🎯 ÖLÇÜM MODU: Radiüslü seçimler için enKisa/merkez/enUzak mesafe toggle
      this.secim1OlcumModu,
      this.secim2OlcumModu,
      this.secim1MerkezBilgisi,
      this.secim2MerkezBilgisi
    );

    // ✅ CACHE STORE: Sonucu cache'e ekle (LRU eviction)
    if (this.hesaplaCache.size >= this.maksKacheUzunlugu) {
      const ilkAnahtarı = this.hesaplaCache.keys().next().value;
      this.hesaplaCache.delete(ilkAnahtarı);
    }
    this.hesaplaCache.set(cacheKey, this.sonuc);

    // 🔴 BUGFIX: Async hesaplama sonrası UI ve render güncelleme
    // OnPush strategy için change detection tetiklenmeli
    this.CD.detectChanges();

    // 🎯 iki yüzey → yönelim GD&T sembolü (paralellik/diklik/açısallık)
    this.gdtGuncelle();

    // 3D sahneyi güncelle (ölçüm çizgileri vs.)
    if (this.anaGosterim?.ciz) {
      this.anaGosterim.ciz();
    }
  }


  ngOnDestroy(): void {
    this.subsList.forEach(element => {
      element.unsubscribe();
    });

    this.haritaOlaylar.forEach((value: any, key: string) => {
      if (value) value();
    });

    // 🎯 YENİ DIMENSION SİSTEMİ: Sadece bu session'daki ölçümleri temizle
    // NOT: dispose() yerine clearSession() kullanıyoruz, kalıcı ölçümler korunsun
    if (this.dimensionService && this.sessionId) {
      const manager = this.dimensionService.getManager();
      if (manager?.clearSession) {
        manager.clearSession(this.sessionId);
      }
      // NOT: dispose() çağırmıyoruz - service paylaşımlı olabilir
      this.dimensionService = null;
    }

    // 🎯 NOKTA KOY: Kalıcı noktaları temizle
    this.kaliciNoktalariTemizle();

    // ⚡ GEOMETRIC SNAP: Temizle
    this.geometricSnap.dispose();

    // Arrow line gösterimini temizle (hover noktalarını da temizler)
    this.gosterimYukleTemizle();

    // 🎯 NOKTA KOY: Hover Points'leri tamamen dispose et
    if (this.hoverNoktaPoints1) {
      if (this.hoverNoktaPoints1.parent) {
        this.hoverNoktaPoints1.parent.remove(this.hoverNoktaPoints1);
      }
      this.hoverNoktaPoints1.geometry?.dispose();
      (this.hoverNoktaPoints1.material as THREE.Material)?.dispose();
      this.hoverNoktaPoints1 = null;
    }
    if (this.hoverNoktaPoints2) {
      if (this.hoverNoktaPoints2.parent) {
        this.hoverNoktaPoints2.parent.remove(this.hoverNoktaPoints2);
      }
      this.hoverNoktaPoints2.geometry?.dispose();
      (this.hoverNoktaPoints2.material as THREE.Material)?.dispose();
      this.hoverNoktaPoints2 = null;
    }

    if (this.fikoSecim1) {
      this.fikoSecim1.ciftSecimModu = false; // Çift seçim modunu kapat
      this.fikoSecim1.aktifSecim = 1;
      this.fikoSecim1.temizle(); // Her iki seçimi de temizle
      this.fikoSecim1.aktif = false; // Shared instance
      // 🎯 Kalıcı seçim modunu kapat, hover highlight'ı varsayılana döndür
      this.fikoSecim1.kaliciSecimModu = false;
      // 🎯 ARAÇ STATE RESTORE: baslat'ta yedeklenen filtre/renk/mod/raycast ayarlarını
      // geri yükle — araçlar arası (kumpas↔cetvel) highlight/seçim karışmasını önler
      if (this._secimDurumYedekli) {
        this.fikoSecim1.durumGeriYukle?.();
        this._secimDurumYedekli = false;
      }
      this.fikoSecim1 = null;
      if (this.anaGosterim && this.anaGosterim.ciz) {
        this.anaGosterim.ciz();
      }
    }
    // fikoSecim2 aynı instance olduğu için sadece null yap
    if (this.fikoSecim2) {
      this.fikoSecim2 = null;
    }

    this.sonuc1Tipi = null;
    this.sonuc2Tipi = null;
    this.secilen1 = null;
    this.secilen2 = null;
    this.sonuc = null;

    // ✅ Cache'i temizle (memory leak önleme)
    this.cacheiTemizle();

    //@ts-ignore
    document.body.style.cursor = "inherit";
  }

  // ===== CACHE YARDIMCI METODLARI =====

  /**
   * ✅ Cache Anahtarı Oluştur
   * Seçim kombinasyonunun benzersiz kimliğini oluştur
   */
  private olusturCacheAnahtarı(): string {
    const sel1Id = this.secilen1?.uuid || this.secilen1?.id || 'unknown1';
    const sel2Id = this.secilen2?.uuid || this.secilen2?.id || 'unknown2';
    const p1Index = this.secilen1PointIndex ?? -1;
    const p2Index = this.secilen2PointIndex ?? -1;
    const birim = this.secilenBirim;
    // 🎯 ÖLÇÜM MODU: Cache anahtarına ölçüm modunu da ekle (enKisa/merkez/enUzak)
    const m1 = this.secim1OlcumModu;
    const m2 = this.secim2OlcumModu;

    return `${sel1Id}_${p1Index}_${sel2Id}_${p2Index}_${birim}_${m1}_${m2}`;
  }

  /**
   * ✅ Cache'i Temizle
   * Seçim değiştiğinde cache'i sıfırla
   */
  private cacheiTemizle(): void {
    this.hesaplaCache.clear();
    this.lastCalculationTime = 0; // 🎯 throttle sıfırla → yeni seçimde hesapla() 16ms throttle'a takılmasın
  }

  // ===== GÖSTERİM METODLARI =====

  /**
   * Gösterim ekleme - Ölçüm çizgisi ekle
   * 🎯 YENİ: useNewDimensionSystem = true ise DimensionIntegrationService kullanır
   */
  private gosterimKayniyaEkle(nokta1: THREE.Vector3, nokta2: THREE.Vector3, label: string, isArc: boolean = false, acı: number = 0, merkezNoktası?: THREE.Vector3, olcumTuru: OlcumTuru = 'mesafe'): void {

    // Sahne kontrol et
    if (!this.anaGosterim || !this.anaGosterim.sahneler[0]) {
      return;
    }

    const sahneFiko = this.anaGosterim.sahneler[0] as any;
    const sahneSonucu = sahneFiko.sahne as any;

    // 🎯 YENİ DIMENSION SİSTEMİ: Aktifse yeni sistemi kullan
    if (this.useNewDimensionSystem && this.dimensionService && !isArc) {
      this.gosterimYeniSistemIle(nokta1, nokta2, label, olcumTuru, merkezNoktası);
      return;
    }

    // ===== ESKİ SİSTEM (FikoOlcumCizgisi) =====
    // İlk çizgi yoksa veya arc modundaysa ilk çizgiyi oluştur, değilse ikinci çizgiyi oluştur
    const ikinciCizgi = this.fikoOlcumCizgisi !== null && !isArc;

    // NOT: Temizleme hesapla() metodunda yapılıyor, burada yapmaya gerek yok

    if (sahneSonucu?.anaGosterim?.aktifKamera) {
      const cam = sahneSonucu.anaGosterim.aktifKamera;
    }

    // ✅ CATIA TARZI: Arc modunda açı türü kullan
    const gercekOlcumTuru = isArc ? 'aci' : olcumTuru;

    // FikoOlcumCizgisi oluştur - ilk veya ikinci çizgi
    const uzunluk = nokta1.distanceTo(nokta2);
    const cizgiRenk = parseInt(this.cizimRengi.replace('#', ''), 16);

    const yeniCizgi = new FikoOlcumCizgisi(
      sahneSonucu,
      `Ölçüm_${label}`,
      nokta1,
      nokta2,
      uzunluk,
      { cizgi: cizgiRenk, ok: cizgiRenk, yazi: this.cizimRengi },
      isArc,
      acı,
      merkezNoktası,
      this.cizgiKalinligi,
      gercekOlcumTuru  // ✅ CATIA tarzı ölçüm türü
    );

    // Yazı ekle - yazı boyutu ve rengi ayarlardan al
    yeniCizgi.yaziEkle(label, undefined, this.yaziBoyutu, this.yaziRengi);

    // İlk veya ikinci çizgiye ata
    if (ikinciCizgi) {
      this.fikoOlcumCizgisi2 = yeniCizgi;
    } else {
      this.fikoOlcumCizgisi = yeniCizgi;
    }

    // 🔴 ÖNEMLI: sahneFiko'ya FikoSahne.ekle() kullan, hazirla() çağrılsın!
    // THREE.js .add() yerine FikoSahne.ekle() kullanmalıyız!
    // 🔴 KRITIK FIX: .add() yerine .ekle() kullan -> hazirla() çağrılacak!
    sahneFiko.ekle(yeniCizgi);

    // 🎯 SÜRÜKLEME DESTEĞİ: Ölçüm çizgisini sürüklenebilir yap
    if (this.anaGosterim?.sunucu && yeniCizgi.draggable) {
      const canvas = this.anaGosterim.sunucu.domElement as HTMLCanvasElement;
      const kamera = this.anaGosterim.aktifKamera;
      const sahneSonucu2 = sahneFiko.sahne;
      if (canvas && kamera && sahneSonucu2) {
        yeniCizgi.suruklemeyiBaslat(canvas, kamera, sahneSonucu2);
      }
    }

    if (this.anaGosterim) {
      this.anaGosterim.ciz();
    }
  }

  /**
   * 🎯 YENİ DIMENSION SİSTEMİ: Profesyonel CATIA/SolidWorks tarzı ölçüm çizgisi
   */
  private gosterimYeniSistemIle(
    nokta1: THREE.Vector3,
    nokta2: THREE.Vector3,
    label: string,
    olcumTuru: OlcumTuru,
    merkezNoktasi?: THREE.Vector3
  ): void {
    if (!this.dimensionService) return;

    // NOT: Cetvel'de birden fazla ölçüm gösterilebilir, clearAll yapmıyoruz
    // Her ölçüm için yeni dimension oluştur

    switch (olcumTuru) {
      case 'cap':
        // Çap ölçümü - 🎯 FikoOlcumCizgisi uyumluluğu: capUc1 ve capUc2 geçir
        // nokta1 = capUc1, nokta2 = capUc2 (çapın iki ucu)
        if (merkezNoktasi) {
          const yaricap = nokta1.distanceTo(merkezNoktasi);
          this.dimensionService.createDiameterMeasurement(
            merkezNoktasi,
            yaricap,
            undefined,
            {
              birim: this.secilenBirim,
              hassasiyet: this.mesafeBas,
              capUc1: nokta1,  // 🎯 Çapın bir ucu
              capUc2: nokta2   // 🎯 Çapın diğer ucu
            }
          );
        } else {
          // Merkez yoksa nokta1-nokta2 arasını çap olarak göster
          const merkez = nokta1.clone().add(nokta2).multiplyScalar(0.5);
          const yaricap = nokta1.distanceTo(nokta2) / 2;
          this.dimensionService.createDiameterMeasurement(
            merkez,
            yaricap,
            undefined,
            {
              birim: this.secilenBirim,
              hassasiyet: this.mesafeBas,
              capUc1: nokta1,  // 🎯 Çapın bir ucu
              capUc2: nokta2   // 🎯 Çapın diğer ucu
            }
          );
        }
        break;

      case 'yaricap':
        // Yarıçap ölçümü - nokta1 = yüzey noktası (eğri yüzeylerde ok pozisyonu)
        if (merkezNoktasi) {
          const yaricap = nokta1.distanceTo(merkezNoktasi);
          this.dimensionService.createRadiusMeasurement(
            merkezNoktasi,
            yaricap,
            undefined,
            {
              birim: this.secilenBirim,
              hassasiyet: this.mesafeBas,
              surfacePoint: nokta1  // Gerçek yüzey noktası - ok burada olacak
            }
          );
        }
        break;

      case 'aci':
        // Açı ölçümü için eski sisteme fallback
        this.useNewDimensionSystem = false;
        this.gosterimKayniyaEkle(nokta1, nokta2, label, true, 0, merkezNoktasi, olcumTuru);
        this.useNewDimensionSystem = true;
        break;

      case 'mesafe':
      case 'uzunluk':
      default:
        // Mesafe/Uzunluk ölçümü
        const _mesafeOpts: any = { birim: this.secilenBirim, hassasiyet: this.mesafeBas, olcumTuru };
        // 🎯 İKİ YÜZEY: uzatma çizgileri yüzeylere değsin (sürüklerken otomatik kessin) diye
        // seçili yüzeylerin SINIR KUTUSUNU (world bbox) ölçüye taşı. Witness ucu bu kutuya kıstırılır
        // → küçük yüzeyde bile çizgi yüzeyin üstüne düşer (düzleme izdüşümde dışarı kaçıyordu).
        try {
          // Klasik (paralel) uzatma seçiliyse bbox GÖNDERME → witness eski paralel haliyle kalır.
          if (!this.klasikUzatma && this.sonuc1Tipi === 'Yüzey' && this.sonuc2Tipi === 'Yüzey' && this.secilen1Geom && this.secilen2Geom) {
            this.secilen1Geom.computeBoundingBox();
            this.secilen2Geom.computeBoundingBox();
            if (this.secilen1Geom.boundingBox) _mesafeOpts.yuzeyBBox1 = this.secilen1Geom.boundingBox.clone();
            if (this.secilen2Geom.boundingBox) _mesafeOpts.yuzeyBBox2 = this.secilen2Geom.boundingBox.clone();
          }
        } catch { /* sessiz */ }
        this.dimensionService.createDistanceMeasurement(nokta1, nokta2, _mesafeOpts);
        break;
    }

    // 🎯 Oluşturulan dimension'a sessionId ekle (clearSession için gerekli)
    const manager = this.dimensionService.getManager();
    if (manager && this.sessionId) {
      const allDims = manager.getAllDimensions();
      if (allDims.length > 0) {
        const sonDim = allDims[allDims.length - 1];
        if (sonDim && !sonDim.userData.sessionId) {
          sonDim.userData.sessionId = this.sessionId;
        }
      }
    }

    // Dimension'ları güncelle
    this.dimensionService.updateAll();

    if (this.anaGosterim) {
      this.anaGosterim.ciz();
    }
  }

  /**
   * Gösterim grubunu sahne'den çıkar ve temizle
   */
  private gosterimYukleTemizle(): void {
    // ⚡ Live preview temizle
    this.previewGizle();

    // 🎯 Hover noktalarını temizle
    this.hoverNoktaTemizle(1);
    this.hoverNoktaTemizle(2);

    // 🎯 YENİ DIMENSION SİSTEMİ: Sadece bu session'daki Dimension'ları temizle
    // NOT: Kalıcı ölçümler (kaliciOlcumlerGrubu'na taşınanlar) korunur
    if (this.dimensionService && this.sessionId) {
      const manager = this.dimensionService.getManager();
      if (manager?.clearSession) {
        manager.clearSession(this.sessionId);
      } else {
        // Fallback: clearAll kullan (eski davranış)
        this.dimensionService.clearAll();
      }
    }

    if (this.fikoOlcumCizgisi) {
      // Sahneden çıkar
      if (this.fikoOlcumCizgisi.parent) {
        this.fikoOlcumCizgisi.parent.remove(this.fikoOlcumCizgisi);
      }
      // Kaynakları serbest bırak
      this.fikoOlcumCizgisi.dispose();
      this.fikoOlcumCizgisi = null;
    }

    // İkinci ölçüm çizgisini de temizle
    if (this.fikoOlcumCizgisi2) {
      if (this.fikoOlcumCizgisi2.parent) {
        this.fikoOlcumCizgisi2.parent.remove(this.fikoOlcumCizgisi2);
      }
      this.fikoOlcumCizgisi2.dispose();
      this.fikoOlcumCizgisi2 = null;
    }

    // 🔴 BUGFIX: Sahnedeki "Ölçüm_Merkeze" ile başlayan tüm FikoOlcumCizgisi objelerini temizle
    // Bu, silindir/küre radiüs ölçümlerinde oluşturulan merkez çizgilerini temizler
    if (this.anaGosterim && this.anaGosterim.sahneler[0]) {
      const sahneFiko = this.anaGosterim.sahneler[0] as any;
      const silinecekler: THREE.Object3D[] = [];

      sahneFiko.traverse((child: THREE.Object3D) => {
        // "Ölçüm_Merkeze" ile başlayan tüm objeleri bul (merkez çizgileri)
        if (child.name && child.name.startsWith('Ölçüm_Merkeze')) {
          silinecekler.push(child);
        }
      });

      // Bulunan objeleri sahne'den çıkar ve dispose et
      for (const obj of silinecekler) {
        if (obj.parent) {
          obj.parent.remove(obj);
        }
        if ((obj as any).dispose) {
          (obj as any).dispose();
        }
      }
    }
  }

  /**
   * 🎯 NOKTA KOY: Hover noktasını göster/güncelle (THREE.Points - GPU, en üstte)
   * @param konum - Nokta konumu (world space)
   * @param kesisim - Raycast kesişim bilgisi
   * @param secimNo - 1 veya 2 (hangi seçim için)
   */
  private hoverNoktaGoster(konum: THREE.Vector3, kesisim: any, secimNo: 1 | 2): void {
    if (!this.anaGosterim || !this.anaGosterim.sahneler[0]) return;

    const sahneFiko = this.anaGosterim.sahneler[0] as any;

    // 🎯 YÜZEYE PROJEKSİYON: Noktayı yüzey face'ine project et (reusable vektörler - performanslı)
    const projectedPoint = this.projectToFace(konum, kesisim);

    // Doğru Points'i seç
    let hoverPoints = secimNo === 1 ? this.hoverNoktaPoints1 : this.hoverNoktaPoints2;

    // Eğer Points yoksa oluştur
    if (!hoverPoints) {
      const geometry = new THREE.BufferGeometry();
      geometry.setAttribute('position', new THREE.Float32BufferAttribute([0, 0, 0], 3));
      const material = new THREE.PointsMaterial({
        color: 0x000000, // 🎯 SİYAH hover noktası
        size: this.noktaKoyBoyutu, // Ayarlardan gelen nokta boyutu
        sizeAttenuation: false, // Kameradan bağımsız sabit boyut
        transparent: true,
        opacity: 1.0,
        depthTest: false,
        depthWrite: false
      });
      hoverPoints = new THREE.Points(geometry, material);
      hoverPoints.name = `HoverNokta_${secimNo}`;
      hoverPoints.renderOrder = 99999; // En üstte
      hoverPoints.frustumCulled = false;
      // 🎯 RAYCAST HARİÇ: Hover noktası raycast'a katılmamalı (aksi halde yüzey yerine noktayı algılar)
      // NOT: layers.set(31) kullanma - kamera görmez! Sadece raycast fonksiyonunu devre dışı bırak
      (hoverPoints as any).raycast = () => {}; // Raycast fonksiyonunu devre dışı bırak
      sahneFiko.add(hoverPoints);

      // Doğru değişkene ata
      if (secimNo === 1) {
        this.hoverNoktaPoints1 = hoverPoints;
      } else {
        this.hoverNoktaPoints2 = hoverPoints;
      }
    } else {
      // Points zaten varsa, boyutu güncelle (ayarlar değişmiş olabilir)
      (hoverPoints.material as THREE.PointsMaterial).size = this.noktaKoyBoyutu;
    }

    // 🎯 v3.2.0: Tüm snap türlerinde SİYAH renk
    let color = 0x000000; // 🎯 SİYAH - varsayılan (yüzey)
    if (kesisim) {
      const altObje = kesisim.altObje;
      const obj = kesisim.object;

      if (altObje?.type === 'Points' || obj?.type === 'Points') {
        color = 0x000000; // 🎯 SİYAH - nokta
      } else if (altObje?.type === 'LineSegments' || altObje?.type === 'LineSegments2' ||
                 obj?.type === 'LineSegments' || obj?.type === 'LineSegments2') {
        color = 0x000000; // 🎯 SİYAH - kenar
      }
    }

    (hoverPoints.material as THREE.PointsMaterial).color.setHex(color);
    // Pozisyonu güncelle (projectedPoint = yüzeye project edilmiş nokta)
    const posAttr = hoverPoints.geometry.attributes['position'] as THREE.BufferAttribute;
    posAttr.setXYZ(0, projectedPoint.x, projectedPoint.y, projectedPoint.z);
    posAttr.needsUpdate = true;
    // Bounding sphere güncelle
    hoverPoints.geometry.computeBoundingSphere();
    hoverPoints.visible = true;

    // 🎯 PERFORMANS: Throttle ile render
    this.throttledCiz();
  }

  /**
   * 🎯 PERFORMANS: Throttle edilmiş render (zoom/pan sırasında takılma önleme)
   */
  private throttledCiz(): void {
    const now = performance.now();
    if (now - this.lastHoverRenderTime < this.HOVER_THROTTLE_MS) {
      return; // Throttle - çok sık render etme
    }
    this.lastHoverRenderTime = now;
    if (this.anaGosterim?.ciz) {
      this.anaGosterim.ciz();
    }
  }

  /**
   * 🎯 NOKTA KOY: Hover noktasını gizle
   * @param secimNo - 1 veya 2 (hangi seçim için)
   */
  private hoverNoktaTemizle(secimNo: 1 | 2): void {
    const hoverPoints = secimNo === 1 ? this.hoverNoktaPoints1 : this.hoverNoktaPoints2;
    if (hoverPoints) {
      hoverPoints.visible = false;
    }
    // 🎯 PERFORMANS: Temizleme için throttle kullanma - zaten throttledCiz çağrılıyor
    // Sadece visible = false yeterli, render hover event'inde yapılacak
  }

  // ================================================================
  // ⚡ LIVE PREVIEW: İlk seçim sonrası hover'da mesafe önizleme
  // ================================================================

  /**
   * ⚡ LIVE PREVIEW: İlk seçim noktasından hover noktasına kesikli çizgi + mesafe etiketi gösterir
   * Sıfır-allocation: Geometry setPositions() ile güncellenir, canvas reuse edilir
   */
  private previewGoster(baslangic: THREE.Vector3, hedef: THREE.Vector3): void {
    if (!this.anaGosterim || !this.anaGosterim.sahneler[0]) return;
    const sahneFiko = this.anaGosterim.sahneler[0] as any;

    // ---- Dashed preview çizgi ----
    if (!this.previewLine) {
      this.previewLineGeometry = new LineGeometry();
      this.previewLineGeometry.setPositions([
        baslangic.x, baslangic.y, baslangic.z,
        hedef.x, hedef.y, hedef.z
      ]);
      const mat = new LineMaterial({
        color: 0x666666,
        linewidth: 1,
        depthTest: false,
        depthWrite: false,
        transparent: true,
        opacity: 0.6,
        fog: false,
        worldUnits: false,
        side: THREE.DoubleSide,
        toneMapped: false,
        dashed: true,
        dashScale: 1,
        dashSize: 3,
        gapSize: 2
      });
      this.previewLine = new LineSegments2(this.previewLineGeometry, mat);
      this.previewLine.name = 'CetvelPreviewLine';
      this.previewLine.renderOrder = 99998;
      this.previewLine.frustumCulled = false;
      this.previewLine.computeLineDistances();
      sahneFiko.add(this.previewLine);
    } else {
      // ⚡ Mevcut geometry'yi güncelle (zero allocation)
      this.previewLineGeometry!.setPositions([
        baslangic.x, baslangic.y, baslangic.z,
        hedef.x, hedef.y, hedef.z
      ]);
      this.previewLine.computeLineDistances();
    }
    this.previewLine.visible = true;

    // ---- Mesafe etiketi ----
    const mesafe = baslangic.distanceTo(hedef);
    const metin = `${mesafe.toFixed(2)} mm`;

    if (!this.previewLabel) {
      // İlk oluşturma: canvas + texture + sprite
      const canvas = document.createElement('canvas');
      canvas.width = 256;
      canvas.height = 64;
      this.previewLabelCanvas = canvas;
      const texture = new THREE.CanvasTexture(canvas);
      texture.minFilter = THREE.LinearFilter;
      texture.magFilter = THREE.LinearFilter;
      this.previewLabelTexture = texture;
      const spriteMat = new THREE.SpriteMaterial({
        map: texture,
        depthTest: false,
        transparent: true
      });
      this.previewLabel = new THREE.Sprite(spriteMat);
      (this.previewLabel as any).raycast = () => {}; // 🎯 tıklamayı engelleme
      this.previewLabel.name = 'CetvelPreviewLabel';
      this.previewLabel.renderOrder = 99999;
      this.previewLabel.frustumCulled = false;
      sahneFiko.add(this.previewLabel);
    }

    // ⚡ Canvas reuse: clear + redraw (zero allocation)
    const canvas = this.previewLabelCanvas!;
    const ctx = canvas.getContext('2d')!;
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.font = 'bold 28px Arial';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    // Arkaplan
    const textWidth = ctx.measureText(metin).width;
    const padding = 12;
    const bgX = (canvas.width - textWidth) / 2 - padding;
    const bgW = textWidth + padding * 2;
    ctx.fillStyle = 'rgba(0,0,0,0.7)';
    ctx.roundRect(bgX, 8, bgW, 48, 6);
    ctx.fill();
    // Yazı
    ctx.fillStyle = '#FFFFFF';
    ctx.fillText(metin, canvas.width / 2, 32);
    this.previewLabelTexture!.needsUpdate = true;

    // Pozisyon: çizgi ortasında
    const scaleFactor = 0.012;
    this.previewLabel.position.lerpVectors(baslangic, hedef, 0.5);
    this.previewLabel.position.y += 5; // Biraz yukarı kaydır
    this.previewLabel.scale.set(canvas.width * scaleFactor, canvas.height * scaleFactor, 1);
    this.previewLabel.visible = true;
  }

  /**
   * ⚡ LIVE PREVIEW: Önizlemeyi gizle
   */
  private previewGizle(): void {
    if (this.previewLine) {
      this.previewLine.visible = false;
    }
    if (this.previewLabel) {
      this.previewLabel.visible = false;
    }
  }

  /**
   * ⚡ LIVE PREVIEW: Önizleme kaynaklarını tamamen temizle
   */
  private previewTemizle(): void {
    if (this.previewLine) {
      if (this.previewLine.parent) this.previewLine.parent.remove(this.previewLine);
      this.previewLineGeometry?.dispose();
      (this.previewLine.material as LineMaterial)?.dispose();
      this.previewLine = null;
      this.previewLineGeometry = null;
    }
    if (this.previewLabel) {
      if (this.previewLabel.parent) this.previewLabel.parent.remove(this.previewLabel);
      this.previewLabelTexture?.dispose();
      (this.previewLabel.material as THREE.SpriteMaterial)?.dispose();
      this.previewLabel = null;
      this.previewLabelCanvas = null;
      this.previewLabelTexture = null;
    }
  }

  /**
   * 🎯 NOKTA KOY: Kalıcı nokta ekle (tıklandığında) - THREE.Points (GPU, en üstte)
   * @param konum - Nokta konumu (world space)
   * @param label - Nokta etiketi
   * @param kesisim - Raycast kesişim bilgisi (projeksiyon için)
   */
  private kaliciNoktaEkle(konum: THREE.Vector3, label: string, kesisim?: any): void {
    if (!this.anaGosterim || !this.anaGosterim.sahneler[0]) return;

    const sahneFiko = this.anaGosterim.sahneler[0] as any;

    // 🎯 YÜZEYE PROJEKSİYON: Noktayı yüzey face'ine project et (reusable vektörler - performanslı)
    const projectedPoint = this.projectToFace(konum, kesisim);

    // Kalıcı nokta Points oluştur (GPU accelerated)
    const geometry = new THREE.BufferGeometry();
    geometry.setAttribute('position', new THREE.Float32BufferAttribute([projectedPoint.x, projectedPoint.y, projectedPoint.z], 3));
    const cizgiRenk = parseInt(this.cizimRengi.replace('#', ''), 16);
    const material = new THREE.PointsMaterial({
      color: cizgiRenk, // Seçim rengi (altın sarısı)
      size: this.noktaKoyBoyutu * 0.5, // Kalıcı noktalar hover'dan biraz küçük
      sizeAttenuation: false, // Kameradan bağımsız sabit boyut
      transparent: true,
      opacity: 1.0,
      depthTest: false,
      depthWrite: false
    });
    const noktaPoints = new THREE.Points(geometry, material);
    noktaPoints.name = `KaliciNokta_${label}_${Date.now()}`;
    noktaPoints.renderOrder = 99998; // En üstte (hover'dan biraz altta)
    noktaPoints.frustumCulled = false;
    // 🎯 RAYCAST HARİÇ: Kalıcı nokta raycast'a katılmamalı (aksi halde yüzey yerine noktayı algılar)
    // NOT: layers.set(31) kullanma - kamera görmez! Sadece raycast fonksiyonunu devre dışı bırak
    (noktaPoints as any).raycast = () => {}; // Raycast fonksiyonunu devre dışı bırak

    // Sahneye ekle ve listeye kaydet
    sahneFiko.add(noktaPoints);
    this.kaliciNoktalar.push(noktaPoints);

    if (this.anaGosterim.ciz) {
      this.anaGosterim.ciz();
    }
  }

  /**
   * 🎯 NOKTA KOY: Tüm kalıcı noktaları temizle
   * Base class metodunu override eder
   */
  protected override kaliciNoktalariTemizle(): void {
    if (!this.kaliciNoktalar || this.kaliciNoktalar.length === 0) return;

    for (const nokta of this.kaliciNoktalar) {
      if (nokta.parent) {
        nokta.parent.remove(nokta);
      }
      nokta.geometry?.dispose();
      (nokta.material as THREE.Material)?.dispose();
    }
    this.kaliciNoktalar = [];

    if (this.anaGosterim && this.anaGosterim.ciz) {
      this.anaGosterim.ciz();
    }
  }

  /**
   * 🎯 YÜZEYE PROJEKSİYON: Noktayı yüzey üzerine project et (performanslı)
   * Face üçgeninin en yakın noktasını bulur
   * @param konum - World space nokta (raycast'tan gelen)
   * @param kesisim - Raycast kesişim bilgisi
   * @returns Project edilmiş nokta (yeni Vector3)
   */
  private projectToFace(konum: THREE.Vector3, kesisim?: any): THREE.Vector3 {
    // Raycast zaten yüzeyde bir nokta veriyor, ama emin olmak için
    // face üçgeninin en yakın noktasını hesapla

    if (!kesisim?.face || !kesisim?.object) return konum.clone();

    const mesh = (kesisim.altObje || kesisim.object) as THREE.Mesh;
    if (!mesh?.geometry) return konum.clone();

    const face = kesisim.face;
    const geom = mesh.geometry as THREE.BufferGeometry;
    const posAttr = geom.attributes['position'];

    if (!posAttr || face.a === undefined) return konum.clone();

    // Face vertex'lerini al (local space) - reusable vektörler kullan
    this._projVA.fromBufferAttribute(posAttr, face.a);
    this._projVB.fromBufferAttribute(posAttr, face.b);
    this._projVC.fromBufferAttribute(posAttr, face.c);

    // World space'e dönüştür (matrixWorld'ü zorla güncelle)
    mesh.updateMatrixWorld(true);
    this._projVA.applyMatrix4(mesh.matrixWorld);
    this._projVB.applyMatrix4(mesh.matrixWorld);
    this._projVC.applyMatrix4(mesh.matrixWorld);

    // 🎯 EN YAKIN NOKTA: Face üçgenine en yakın noktayı bul
    const triangle = new THREE.Triangle(this._projVA, this._projVB, this._projVC);
    const closestPoint = new THREE.Vector3();
    triangle.closestPointToPoint(konum, closestPoint);

    return closestPoint;
  }

  /**
   * 🎯 HOVER AYARLARI: localStorage'dan hover modunu yükle
   * Kumpas/Cetvel geçişlerinde hover modunun kapanmasını önler
   * Base class metodunu override eder
   */
  protected override hoverAyarlariYukle(): void {
    if (!this.fikoSecim1) return;
    try {
      const kaydedilen = localStorage.getItem('FikoThreeJSAyarlari');
      if (kaydedilen) {
        const ayarlar = JSON.parse(kaydedilen);
        // Hover highlight tip ayarları
        if (ayarlar.hoverHighlightMesh !== undefined) {
          this.fikoSecim1.hoverHighlightMesh = ayarlar.hoverHighlightMesh;
        }
        if (ayarlar.hoverHighlightLine !== undefined) {
          this.fikoSecim1.hoverHighlightLine = ayarlar.hoverHighlightLine;
        }
        if (ayarlar.hoverHighlightPoint !== undefined) {
          this.fikoSecim1.hoverHighlightPoint = ayarlar.hoverHighlightPoint;
        }
        if (ayarlar.hoverHighlightEdge !== undefined) {
          this.fikoSecim1.hoverHighlightEdge = ayarlar.hoverHighlightEdge;
        }
        // Genel hover ayarı
        if (ayarlar.hoverHighlightEnabled !== undefined) {
          this.fikoSecim1.hoverHighlightEnabled = ayarlar.hoverHighlightEnabled;
        } else {
          // Ayar yoksa varsayılan true
          this.fikoSecim1.hoverHighlightEnabled = true;
        }
      } else {
        // Ayar dosyası yoksa varsayılan true
        this.fikoSecim1.hoverHighlightEnabled = true;
      }
    } catch (e) {
      // Hata durumunda varsayılan true
      this.fikoSecim1.hoverHighlightEnabled = true;
    }
  }

  /**
   * 🎯 AKILLI ÇAP: Dairesel kenar üzerinde hover'da çapı otomatik önizle (donmasız:
   * yalnız KENAR hover + kenar DEĞİŞİNCE + BREP metadata radius → fit YOK, O(1), sprite reuse).
   */
  private akilliCapOnizle(kesisim: any): void {
    const e = kesisim?.altObje || kesisim?.object;
    const kenarHover = e && (e.type === 'LineSegments2' || e.type === 'LineSegments');
    if (!kenarHover) { this.silindirYuzeyCapOnizle(kesisim, e); return; }

    const edgeId = (this.fikoSecim1 as any)?.sonSecilenEdgeGrupIdUzerinde ?? -1;
    if (edgeId < 0) { this.cemberPreviewGizle(); return; }
    if (edgeId === this._sonCemberEdgeId) return; // kenar değişmedi → tekrar hesaplama yok
    this._sonCemberEdgeId = edgeId;

    let cizim: any = kesisim?.object;
    while (cizim && cizim.type !== 'FikoCizimYalin' && !cizim.occt_edgeGroups) cizim = cizim.parent;
    const edgeGroups = cizim?.occt_edgeGroups;
    if (!edgeGroups || edgeId >= edgeGroups.length) { this.cemberPreviewGizle(); return; }

    const eg = edgeGroups[edgeId];
    const r = eg?.radius;
    const c = eg?.center;
    if (r && r > 0 && c) {
      const merkez = new THREE.Vector3(c.x ?? c[0] ?? 0, c.y ?? c[1] ?? 0, c.z ?? c[2] ?? 0);
      if (cizim?.matrixWorld) merkez.applyMatrix4(cizim.matrixWorld);
      this.cemberPreviewGoster(merkez, r * 2);
    } else {
      this.cemberPreviewGizle();
    }
  }

  /**
   * 🎯 AKILLI ÇAP (YÜZEY): Silindirik/küresel yüzeye gelince çapı imlecin değdiği noktada önizle.
   * GÜVENLİ: yüzey değişince (faceIndex cache) + grup→occt_faceGroups.radius (fit YOK, O(1)).
   */
  private silindirYuzeyCapOnizle(kesisim: any, mesh: any): void {
    const faceIdx = kesisim?.face?.a ?? kesisim?.faceIndex ?? -1;
    const grupAttr = mesh?.geometry?.attributes?.grup;
    if (faceIdx < 0 || !grupAttr || !kesisim?.point) { this.cemberPreviewGizle(); return; }

    const key = 1000000 + faceIdx;
    if (key === this._sonCemberEdgeId) return;
    this._sonCemberEdgeId = key;

    const grp = Math.round(grupAttr.getZ(faceIdx));
    let cizim: any = kesisim.object;
    while (cizim && cizim.type !== 'FikoCizimYalin' && !cizim.occt_faceGroups) cizim = cizim.parent;
    const fg = cizim?.occt_faceGroups?.[grp];
    const r = fg?.radius;
    if (r && r > 0) {
      this.cemberPreviewGoster(kesisim.point.clone(), r * 2);
    } else {
      this.cemberPreviewGizle();
    }
  }

  /** 🎯 AKILLI ÇAP: Çap önizleme sprite'ı göster (canvas reuse). */
  private cemberPreviewGoster(merkez: THREE.Vector3, cap: number): void {
    if (!this.anaGosterim?.sahneler[0]) return;
    const sahneFiko = this.anaGosterim.sahneler[0] as any;
    const metin = `⌀ ${cap.toFixed(this.mesafeBas)} mm`;

    if (!this.cemberPreviewSprite) {
      const canvas = document.createElement('canvas');
      canvas.width = 256; canvas.height = 64;
      this.cemberPreviewCanvas = canvas;
      this.cemberPreviewTexture = new THREE.CanvasTexture(canvas);
      this.cemberPreviewTexture.minFilter = THREE.LinearFilter;
      this.cemberPreviewTexture.magFilter = THREE.LinearFilter;
      const mat = new THREE.SpriteMaterial({ map: this.cemberPreviewTexture, depthTest: false, transparent: true });
      this.cemberPreviewSprite = new THREE.Sprite(mat);
      (this.cemberPreviewSprite as any).raycast = () => {}; // 🎯 tıklamayı engelleme (seçim sprite'a çarpmasın)
      this.cemberPreviewSprite.name = 'CetvelCemberPreview';
      this.cemberPreviewSprite.renderOrder = 99999;
      this.cemberPreviewSprite.frustumCulled = false;
      sahneFiko.add(this.cemberPreviewSprite);
    }

    if (this.cemberPreviewSonCap !== cap) {
      this.cemberPreviewSonCap = cap;
      const canvas = this.cemberPreviewCanvas!;
      const ctx = canvas.getContext('2d')!;
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.font = 'bold 28px Arial';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      const tw = ctx.measureText(metin).width;
      const pad = 12;
      ctx.fillStyle = 'rgba(0,0,0,0.78)';
      (ctx as any).roundRect((canvas.width - tw) / 2 - pad, 8, tw + pad * 2, 48, 6);
      ctx.fill();
      ctx.fillStyle = '#4aa8ff';
      ctx.fillText(metin, canvas.width / 2, 32);
      this.cemberPreviewTexture!.needsUpdate = true;
    }

    const cv = this.cemberPreviewCanvas!;
    this.cemberPreviewSprite.position.copy(merkez);
    this.cemberPreviewSprite.scale.set(cv.width * 0.012, cv.height * 0.012, 1);
    this.cemberPreviewSprite.visible = true;
    if (this.anaGosterim.ciz) this.anaGosterim.ciz();
  }

  /** 🎯 AKILLI ÇAP: Önizlemeyi gizle */
  private cemberPreviewGizle(): void {
    this._sonCemberEdgeId = undefined;
    if (this.cemberPreviewSprite?.visible) {
      this.cemberPreviewSprite.visible = false;
      if (this.anaGosterim?.ciz) this.anaGosterim.ciz();
    }
  }

  /** 🎯 AKILLI ÇAP: Kaynakları tamamen temizle */
  private cemberPreviewTemizle(): void {
    if (this.cemberPreviewSprite) {
      if (this.cemberPreviewSprite.parent) this.cemberPreviewSprite.parent.remove(this.cemberPreviewSprite);
      this.cemberPreviewTexture?.dispose();
      (this.cemberPreviewSprite.material as THREE.SpriteMaterial)?.dispose();
      this.cemberPreviewSprite = null;
      this.cemberPreviewCanvas = null;
      this.cemberPreviewTexture = null;
      this.cemberPreviewSonCap = -1;
    }
    this._sonCemberEdgeId = undefined;
  }

  bitir() {
    // 🎯 GD&T FCF sembollerini temizle
    this.gdtAnnotator?.temizle();
    // 🎯 AKILLI ÇAP: önizleme kaynaklarını temizle
    this.cemberPreviewTemizle();

    // Tüm subscription'ları temizle
    this.subsList.forEach(element => {
      element.unsubscribe();
    });
    this.subsList = []; // Array'i temizle

    this.haritaOlaylar.forEach((value: any, key: string) => {
      if (value) value();
    });
    this.haritaOlaylar.clear();

    // 🎯 YENİ DIMENSION SİSTEMİ: Sadece bu session'daki ölçümleri temizle
    // NOT: dispose() yerine clearSession() kullanıyoruz, kalıcı ölçümler korunsun
    if (this.dimensionService && this.sessionId) {
      const manager = this.dimensionService.getManager();
      if (manager?.clearSession) {
        manager.clearSession(this.sessionId);
      }
      // NOT: dispose() çağırmıyoruz - service paylaşımlı olabilir
      this.dimensionService = null;
    }

    // 🎯 NOKTA KOY: Kalıcı noktaları temizle
    this.kaliciNoktalariTemizle();

    // Arrow line gösterimini temizle (hover noktalarını da temizler)
    this.gosterimYukleTemizle();

    // ⚡ LIVE PREVIEW: Kaynakları tamamen serbest bırak
    this.previewTemizle();

    // 🎯 NOKTA KOY: Hover Points'leri tamamen dispose et
    if (this.hoverNoktaPoints1) {
      if (this.hoverNoktaPoints1.parent) {
        this.hoverNoktaPoints1.parent.remove(this.hoverNoktaPoints1);
      }
      this.hoverNoktaPoints1.geometry?.dispose();
      (this.hoverNoktaPoints1.material as THREE.Material)?.dispose();
      this.hoverNoktaPoints1 = null;
    }
    if (this.hoverNoktaPoints2) {
      if (this.hoverNoktaPoints2.parent) {
        this.hoverNoktaPoints2.parent.remove(this.hoverNoktaPoints2);
      }
      this.hoverNoktaPoints2.geometry?.dispose();
      (this.hoverNoktaPoints2.material as THREE.Material)?.dispose();
      this.hoverNoktaPoints2 = null;
    }

    if (this.fikoSecim1) {
      this.fikoSecim1.ciftSecimModu = false; // Çift seçim modunu kapat
      this.fikoSecim1.aktifSecim = 1;
      this.fikoSecim1.temizle(); // Her iki seçimi de temizle
      this.fikoSecim1.aktif = false; // Shared instance
      // 🎯 Kalıcı seçim modunu kapat, hover highlight'ı varsayılana döndür
      this.fikoSecim1.kaliciSecimModu = false;
      // 🎯 ARAÇ STATE RESTORE: baslat'ta yedeklenen filtre/renk/mod/raycast ayarlarını
      // geri yükle — araçlar arası (kumpas↔cetvel) highlight/seçim karışmasını önler
      if (this._secimDurumYedekli) {
        this.fikoSecim1.durumGeriYukle?.();
        this._secimDurumYedekli = false;
      }
      this.fikoSecim1 = null;
      if (this.anaGosterim && this.anaGosterim.ciz) {
        this.anaGosterim.ciz();
      }
    }
    // fikoSecim2 aynı instance olduğu için sadece null yap
    if (this.fikoSecim2) {
      this.fikoSecim2 = null;
    }

    this.sonuc1Tipi = null;
    this.sonuc2Tipi = null;
    this.secilen1 = null;
    this.secilen2 = null;
    this.sonuc = null;
    //@ts-ignore
    document.body.style.cursor = "inherit";

    // 🎯 SESSION: Session ID'yi temizle
    this.sessionId = '';
    this.kaliciOlcumlerGrubu = null;
  }

  // ========== KALICI ÖLÇÜM SİSTEMİ ==========

  /**
   * 🎯 SESSION ID: Benzersiz session ID üret
   * Format: cetvel_YYYYMMDD_HHmmss_random
   */
  private generateSessionId(): string {
    const now = new Date();
    const dateStr = now.toISOString().replace(/[-:T.Z]/g, '').slice(0, 14);
    const random = Math.random().toString(36).substring(2, 8);
    return `cetvel_${dateStr}_${random}`;
  }

  /**
   * 🎯 KALICI ÖLÇÜMLER GRUBU: FikoKaynakca altındaki grubu bul
   */
  private kaliciOlcumlerGrubuBul(sahne: any): void {
    // FikoKaynakca'yı bul - önce doğrudan sahne'de ara
    let kaynakca = sahne.getObjectByProperty?.('type', 'FikoKaynakca') as FikoKaynakca;

    // Bulunamazsa sahne.children içinde recursive ara
    if (!kaynakca) {
      sahne.traverse?.((child: any) => {
        if (child.type === 'FikoKaynakca') {
          kaynakca = child;
        }
      });
    }

    if (kaynakca && kaynakca.kaliciOlcumler) {
      this.kaliciOlcumlerGrubu = kaynakca.kaliciOlcumler;
      // console.log('[Cetvel] Kalıcı ölçümler grubu bulundu:', this.kaliciOlcumlerGrubu);
    } else {
      console.warn('[Cetvel] FikoKaynakca veya kaliciOlcumler bulunamadı!', { kaynakca, sahne });
    }
  }

  /**
   * 🎯 ÖLÇÜM KALICI OLSUN: Mevcut ölçümü kalıcı gruba aktar
   * Bu metod template'ten çağrılır
   */
  olcumKaliciYap(): void {
    if (!this.kaliciOlcumlerGrubu) {
      console.warn('[Cetvel] Kalıcı ölçümler grubu bulunamadı');
      return;
    }

    // Mevcut ölçüm var mı kontrol et
    if (!this.sonuc || this.sonuc.turu !== 'Mesafe') {
      console.warn('[Cetvel] Aktif ölçüm yok');
      return;
    }

    // Ölçüm başlığını oluştur
    const olcumDegeri = this.sonuc.mesafe?.olcu?.toFixed(this.mesafeBas) || '0';
    const birim = this.secilenBirim;
    const baslik = `${olcumDegeri} ${birim}`;

    // 🎯 YENİ DIMENSION SİSTEMİ: DimensionManager'dan son dimension'ı al
    if (this.useNewDimensionSystem && this.dimensionService) {
      const manager = this.dimensionService.getManager();
      if (manager) {
        const allDimensions = manager.getAllDimensions();
        if (allDimensions.length > 0) {
          // Son eklenen dimension'ı al
          const sonDimension = allDimensions[allDimensions.length - 1];

          // 🎯 Dimension'ı THREE.Group olarak DERİN klonla (geometri ve materyal dahil)
          const klonGrup = new THREE.Group();
          klonGrup.name = `KaliciOlcum_${baslik}`;

          // Tüm child'ları derin klonla (mesh, line, sprite vb.)
          sonDimension.children.forEach((child: THREE.Object3D) => {
            const klonChild = this.derinKlonla(child);
            klonGrup.add(klonChild);
          });

          // Pozisyon ve rotasyonu kopyala
          klonGrup.position.copy(sonDimension.position);
          klonGrup.rotation.copy(sonDimension.rotation);
          klonGrup.scale.copy(sonDimension.scale);

          // 🎯 v3.0.5: Orijinal ölçüm noktalarını userData'ya kaydet (sürükleme için kritik!)
          if (typeof (sonDimension as any).getOriginalPoints === 'function') {
            const orijinalNoktalar = (sonDimension as any).getOriginalPoints();
            klonGrup.userData.startPoint = orijinalNoktalar.pointA.clone();
            klonGrup.userData.endPoint = orijinalNoktalar.pointB.clone();
            // console.log('[Cetvel] v3.0.5 Orijinal noktalar kaydedildi:', orijinalNoktalar.pointA.toArray(), orijinalNoktalar.pointB.toArray());
          }

          // 🎯 v3.2.5: Sabit boyut sistemi için varsayılan ayar
          klonGrup.userData.sabitBoyut = true;

          // 🎯 v3.2.9: Gerçek değerleri userData'ya kaydet (düzenleme dialogu için)
          if (this.sonuc.mesafe?.olcu !== undefined) {
            klonGrup.userData.gercekDeger = this.sonuc.mesafe.olcu;   // 🎯 EN ÖNEMLİ - dialog tekrar açıldığında bu kullanılacak
            klonGrup.userData.uzunluk = this.sonuc.mesafe.olcu;       // 🎯 Gerçek sayı (yuvarlanmamış)
            klonGrup.userData.mesafe = this.sonuc.mesafe.olcu;        // 🎯 Gerçek sayı
            klonGrup.userData.olcumTipi = 'mesafe';
          }

          // Kalıcı gruba ekle
          this.kaliciOlcumlerGrubu.kaliciOlcumEkle(klonGrup, baslik, this.sessionId);

          // console.log('[Cetvel] Ölçüm kalıcı yapıldı:', baslik, {
          //   kaliciGrup: this.kaliciOlcumlerGrubu,
          //   childrenCount: this.kaliciOlcumlerGrubu.children.length,
          //   klonGrup: klonGrup
          // });

          // 🎯 Sahne ağacını güncelle (ürün ağacı için gerekli)
          if (this.kaliciOlcumlerGrubu.sahne) {
            (this.kaliciOlcumlerGrubu.sahne as any).dispatchEvent?.({ type: 'childadded' });
          }
          this.FikoYT?.degisti?.emit();   // 🎯 Angular ürün ağacını yenile → kalıcı ölçüm ağaçta görünsün
      try { this.fikoSecim1?.temizle?.(); this.fikoSecim2?.temizle?.(); } catch (e) { }   // 📌 sonrası seçim highlight noktalarını temizle (orphan kalmasın)

          // UI güncelle
          if (this.anaGosterim?.ciz) {
            this.anaGosterim.ciz();
          }
          this.CD.detectChanges();
          return;
        }
      }
    }

    // 🎯 ESKİ SİSTEM: FikoOlcumCizgisi kullanılıyorsa
    if (this.fikoOlcumCizgisi) {
      // FikoOlcumCizgisi'ni klonla
      const klonGrup = this.fikoOlcumCizgisi.clone(true) as THREE.Group;
      klonGrup.name = `KaliciOlcum_${baslik}`;

      // Kalıcı gruba ekle
      this.kaliciOlcumlerGrubu.kaliciOlcumEkle(klonGrup, baslik, this.sessionId);
      this.FikoYT?.degisti?.emit();   // 🎯 Angular ürün ağacını yenile → kalıcı ölçüm ağaçta görünsün
      try { this.fikoSecim1?.temizle?.(); this.fikoSecim2?.temizle?.(); } catch (e) { }   // 📌 sonrası seçim highlight noktalarını temizle (orphan kalmasın)

      // UI güncelle
      if (this.anaGosterim?.ciz) {
        this.anaGosterim.ciz();
      }
      this.CD.detectChanges();
    }
  }

  /**
   * 🎯 KALICI ÖLÇÜM VAR MI: Mevcut aktif ölçüm var mı kontrol et
   */
  get kaliciYapilabilirMi(): boolean {
    return this.sonuc?.turu === 'Mesafe' && this.kaliciOlcumlerGrubu !== null;
  }

  /**
   * 🎯 DERİN KLONLAMA: Geometri ve materyalleri ayrı ayrı klonlar
   * DimensionManager.clearAll() çağrıldığında kalıcı ölçümlerin silinmesini önler
   */
  private derinKlonla(obj: THREE.Object3D): THREE.Object3D {
    // Mesh için derin klonlama
    if (obj instanceof THREE.Mesh) {
      const yeniGeometri = obj.geometry?.clone();
      let yeniMateryal: THREE.Material | THREE.Material[];

      if (Array.isArray(obj.material)) {
        yeniMateryal = obj.material.map(m => m.clone());
      } else if (obj.material) {
        yeniMateryal = obj.material.clone();
      } else {
        yeniMateryal = new THREE.MeshBasicMaterial();
      }

      const yeniMesh = new THREE.Mesh(yeniGeometri, yeniMateryal);
      yeniMesh.name = obj.name;
      yeniMesh.position.copy(obj.position);
      yeniMesh.rotation.copy(obj.rotation);
      yeniMesh.scale.copy(obj.scale);
      yeniMesh.visible = obj.visible;
      yeniMesh.renderOrder = obj.renderOrder;
      yeniMesh.userData = { ...obj.userData };

      // Çocukları recursive olarak klonla
      obj.children.forEach(child => {
        yeniMesh.add(this.derinKlonla(child));
      });

      return yeniMesh;
    }

    // Line/LineSegments için derin klonlama
    if (obj instanceof THREE.Line || obj instanceof THREE.LineSegments) {
      const yeniGeometri = obj.geometry?.clone();
      let yeniMateryal: THREE.Material | THREE.Material[];

      if (Array.isArray(obj.material)) {
        yeniMateryal = obj.material.map(m => m.clone());
      } else if (obj.material) {
        yeniMateryal = obj.material.clone();
      } else {
        yeniMateryal = new THREE.LineBasicMaterial();
      }

      const YeniSinif = obj.constructor as new (geometry?: THREE.BufferGeometry, material?: THREE.Material | THREE.Material[]) => THREE.Line;
      const yeniLine = new YeniSinif(yeniGeometri, yeniMateryal);
      yeniLine.name = obj.name;
      yeniLine.position.copy(obj.position);
      yeniLine.rotation.copy(obj.rotation);
      yeniLine.scale.copy(obj.scale);
      yeniLine.visible = obj.visible;
      yeniLine.renderOrder = obj.renderOrder;
      yeniLine.userData = { ...obj.userData };

      // Çocukları recursive olarak klonla
      obj.children.forEach(child => {
        yeniLine.add(this.derinKlonla(child));
      });

      return yeniLine;
    }

    // Sprite için derin klonlama
    if (obj instanceof THREE.Sprite) {
      const eskiMateryal = obj.material as THREE.SpriteMaterial;
      const yeniMateryal = new THREE.SpriteMaterial();

      // Materyal özelliklerini kopyala
      yeniMateryal.color.copy(eskiMateryal.color);
      yeniMateryal.opacity = eskiMateryal.opacity;
      yeniMateryal.transparent = eskiMateryal.transparent;
      yeniMateryal.depthTest = eskiMateryal.depthTest;
      yeniMateryal.depthWrite = eskiMateryal.depthWrite;
      yeniMateryal.sizeAttenuation = eskiMateryal.sizeAttenuation;

      // 🎯 Texture'ı GERÇEK klonla (canvas içeriğini kopyala)
      if (eskiMateryal.map) {
        const eskiTexture = eskiMateryal.map;
        const eskiImage = eskiTexture.image;

        if (eskiImage instanceof HTMLCanvasElement) {
          // Canvas'ı yeni bir canvas'a kopyala
          const yeniCanvas = document.createElement('canvas');
          yeniCanvas.width = eskiImage.width;
          yeniCanvas.height = eskiImage.height;
          const ctx = yeniCanvas.getContext('2d');
          if (ctx) {
            ctx.drawImage(eskiImage, 0, 0);
          }

          // Yeni CanvasTexture oluştur
          const yeniTexture = new THREE.CanvasTexture(yeniCanvas);
          yeniTexture.minFilter = eskiTexture.minFilter;
          yeniTexture.magFilter = eskiTexture.magFilter;
          yeniTexture.wrapS = eskiTexture.wrapS;
          yeniTexture.wrapT = eskiTexture.wrapT;
          yeniTexture.needsUpdate = true;

          yeniMateryal.map = yeniTexture;
        } else if (eskiImage instanceof HTMLImageElement) {
          // Image için yeni texture oluştur
          const yeniTexture = new THREE.Texture(eskiImage.cloneNode(true) as HTMLImageElement);
          yeniTexture.minFilter = eskiTexture.minFilter;
          yeniTexture.magFilter = eskiTexture.magFilter;
          yeniTexture.needsUpdate = true;
          yeniMateryal.map = yeniTexture;
        } else {
          // Diğer durumlar için basit clone
          yeniMateryal.map = eskiTexture.clone();
          yeniMateryal.map.needsUpdate = true;
        }
      }

      yeniMateryal.needsUpdate = true;

      const yeniSprite = new THREE.Sprite(yeniMateryal);
      yeniSprite.name = obj.name;
      yeniSprite.position.copy(obj.position);
      yeniSprite.rotation.copy(obj.rotation);
      yeniSprite.scale.copy(obj.scale);
      yeniSprite.visible = obj.visible;
      yeniSprite.renderOrder = obj.renderOrder;
      yeniSprite.userData = { ...obj.userData };

      // 🎯 v3.2.5: Sabit boyut sistemi için originalScale ekle
      // Eğer kaynak sprite'ta originalScale varsa kopyala, yoksa mevcut scale'i kaydet
      if (obj.userData.originalScale) {
        yeniSprite.userData.originalScale = (obj.userData.originalScale as THREE.Vector3).clone();
      } else {
        // originalScale yoksa mevcut scale'i base olarak kaydet
        yeniSprite.userData.originalScale = yeniSprite.scale.clone();
      }
      yeniSprite.userData.isLabel = true;

      return yeniSprite;
    }

    // Points için derin klonlama
    if (obj instanceof THREE.Points) {
      const yeniGeometri = obj.geometry?.clone();
      let yeniMateryal: THREE.Material | THREE.Material[];

      if (Array.isArray(obj.material)) {
        yeniMateryal = obj.material.map(m => m.clone());
      } else if (obj.material) {
        yeniMateryal = obj.material.clone();
      } else {
        yeniMateryal = new THREE.PointsMaterial();
      }

      const yeniPoints = new THREE.Points(yeniGeometri, yeniMateryal);
      yeniPoints.name = obj.name;
      yeniPoints.position.copy(obj.position);
      yeniPoints.rotation.copy(obj.rotation);
      yeniPoints.scale.copy(obj.scale);
      yeniPoints.visible = obj.visible;
      yeniPoints.renderOrder = obj.renderOrder;
      yeniPoints.userData = { ...obj.userData };

      return yeniPoints;
    }

    // Group veya diğer Object3D için
    if (obj instanceof THREE.Group || obj instanceof THREE.Object3D) {
      const yeniGrup = new THREE.Group();
      yeniGrup.name = obj.name;
      yeniGrup.position.copy(obj.position);
      yeniGrup.rotation.copy(obj.rotation);
      yeniGrup.scale.copy(obj.scale);
      yeniGrup.visible = obj.visible;
      yeniGrup.renderOrder = obj.renderOrder;
      yeniGrup.userData = { ...obj.userData };

      // Çocukları recursive olarak klonla
      obj.children.forEach(child => {
        yeniGrup.add(this.derinKlonla(child));
      });

      return yeniGrup;
    }

    // Fallback: standart clone (nadir durumlar için)
    console.warn('[Cetvel] Bilinmeyen obje tipi, standart clone kullanılıyor:', (obj as any).type);
    return (obj as THREE.Object3D).clone(true);
  }
}
